var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmerald(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 56,
    viewBox: "0 0 94 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.986 13.7961C51.9197 14.9584 49.7744 15.1424 48.4685 13.3875C48.3885 13.288 48.334 13.1876 48.2588 13.0778C48.2315 13.0276 48.2043 12.9774 48.1666 12.9224C46.9059 10.6857 48.2055 8.75701 50.4376 7.5074C52.6745 6.24741 61.5129 5.41608 61.5129 5.41608C61.5129 5.41608 56.2333 12.5409 53.986 13.7961Z",
    fill: "url(#paint0_radial_578_447510)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5334 5.42535L48.4843 13.4072C48.4043 13.3077 48.3497 13.2073 48.2745 13.0974C48.2473 13.0472 48.2201 12.997 48.1824 12.9421C46.9216 10.7054 48.2212 8.77667 50.4533 7.52705C52.6902 6.26706 61.5334 5.42535 61.5334 5.42535Z",
    fill: "url(#paint1_radial_578_447510)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6529 13.1788C51.8574 14.189 49.9998 14.2663 48.9945 12.486C47.9893 10.7058 49.0306 9.14843 50.8213 8.14857C51.4984 7.76832 52.9183 7.43992 54.4372 7.16955C54.5743 7.14453 54.6963 7.12515 54.8335 7.10014C57.2319 6.69312 59.6977 6.46781 59.6977 6.46781C59.6977 6.46781 59.0226 7.36398 58.1056 8.51351C57.7278 8.98085 57.3158 9.49534 56.8727 9.99551C55.7082 11.3832 54.4455 12.7385 53.6529 13.1788Z",
    fill: "url(#paint2_radial_578_447510)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.046 12.8695C53.9369 12.9703 53.827 13.0456 53.7227 13.1359C53.7872 13.0776 53.9019 12.9919 54.046 12.8695Z",
    fill: "url(#paint3_radial_578_447510)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6689 13.1734C53.653 13.1793 53.6639 13.1843 53.6689 13.1734C53.6639 13.1843 53.6639 13.1843 53.6689 13.1734Z",
    fill: "url(#paint4_radial_578_447510)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.536 6.51924C59.536 6.51924 55.2819 12.2303 53.4912 13.2302C53.1152 13.4471 52.7224 13.6186 52.3534 13.7382C52.7886 13.6113 53.2268 13.423 53.6634 13.1836C55.4589 12.1733 59.7082 6.47263 59.7082 6.47263C59.7082 6.47263 54.3084 6.98489 51.7442 7.78063C54.3603 7.0087 59.536 6.51924 59.536 6.51924Z",
    fill: "url(#paint5_radial_578_447510)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0882 12.5292C48.0773 10.7338 49.1242 9.19157 50.915 8.1917C52.5751 7.25751 58.722 6.62323 59.6694 6.53031C59.6988 6.49356 59.7036 6.48319 59.7036 6.48319C59.7036 6.48319 52.6076 7.15937 50.8272 8.164C49.0316 9.17424 47.9951 10.7211 49.0004 12.5014C49.3536 13.1283 49.8116 13.5269 50.3298 13.7395C49.8515 13.4949 49.4198 13.121 49.0882 12.5292Z",
    fill: "url(#paint6_radial_578_447510)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5332 5.4254C61.5332 5.4254 60.4741 5.84394 59.7027 6.45725C59.6979 6.46763 60.6635 6.00623 61.5332 5.4254Z",
    fill: "url(#paint7_radial_578_447510)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5095 7.7005C59.1563 8.14147 58.7738 8.61916 58.3761 9.10249C57.0995 10.6523 55.6373 12.3054 54.5236 13.2265C54.2354 13.4711 53.971 13.6639 53.7352 13.7944C52.7721 14.3323 51.7918 14.6614 50.8777 14.6817C51.8606 14.7306 52.9326 14.3934 53.9961 13.801C54.2319 13.6705 54.4963 13.4778 54.7844 13.2331C55.903 12.3017 57.35 10.6542 58.6369 9.10911C59.0346 8.62578 59.422 8.13768 59.7703 7.70709C60.7804 6.43694 61.5039 5.46245 61.5286 5.43608L61.0674 5.70187C60.7684 6.07971 60.2157 6.81857 59.5095 7.7005Z",
    fill: "url(#paint8_radial_578_447510)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6368 9.10906C58.3903 8.76985 58.2169 8.62746 58.2169 8.62746L59.4519 7.05854C59.5873 7.28395 59.6971 7.51025 59.7853 7.70146C59.417 8.14804 59.0345 8.62574 58.6368 9.10906Z",
    fill: "url(#paint9_radial_578_447510)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8838 10.0003C56.0021 8.85454 55.1576 7.90172 54.4276 7.16479C54.5647 7.13978 54.6867 7.12037 54.8238 7.09536C57.2222 6.68834 59.688 6.46303 59.688 6.46303C59.688 6.46303 59.0129 7.3592 58.0959 8.50873C57.7285 8.98083 57.3166 9.49533 56.8838 10.0003Z",
    fill: "url(#paint10_radial_578_447510)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2856 13.863C42.4514 14.8274 44.6045 14.8105 45.741 12.9414C45.8113 12.8348 45.8562 12.7298 45.9209 12.6134C45.9433 12.5609 45.9658 12.5084 45.9981 12.4502C47.0447 10.1056 45.5708 8.30654 43.2319 7.27062C40.8872 6.2248 32.0098 6.22168 32.0098 6.22168C32.0098 6.22168 37.9409 12.8171 40.2856 13.863Z",
    fill: "url(#paint11_radial_578_447510)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32 6.22717L45.7411 12.9412C45.8115 12.8346 45.8564 12.7296 45.921 12.6132C45.9435 12.5607 45.9659 12.5082 45.9982 12.45C47.0449 10.1054 45.571 8.30632 43.232 7.2704C40.8832 6.24018 32 6.22717 32 6.22717Z",
    fill: "url(#paint12_radial_578_447510)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5683 13.2116C42.4503 14.0499 44.307 13.9536 45.1418 12.0873C45.9807 10.2054 44.7945 8.76762 42.9183 7.93919C42.2086 7.62377 40.7644 7.42927 39.2269 7.30177C39.088 7.28967 38.9647 7.28176 38.8258 7.26965C36.3999 7.08816 33.9238 7.09387 33.9238 7.09387C33.9238 7.09387 34.6796 7.92315 35.6998 8.98212C36.1196 9.41217 36.5777 9.88599 37.0656 10.3426C38.3446 11.6214 39.7381 12.8472 40.5683 13.2116Z",
    fill: "url(#paint13_radial_578_447510)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1484 12.9406C40.2664 13.0307 40.3829 13.0954 40.4952 13.1756C40.4255 13.1235 40.3033 13.0489 40.1484 12.9406Z",
    fill: "url(#paint14_radial_578_447510)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5537 13.2075C40.5597 13.2179 40.5701 13.2119 40.5537 13.2075C40.5597 13.2179 40.5597 13.2179 40.5537 13.2075Z",
    fill: "url(#paint15_radial_578_447510)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0908 7.12995C34.0908 7.12995 38.8591 12.4193 40.7354 13.2477C41.1299 13.4286 41.537 13.5627 41.9156 13.6473C41.4704 13.5616 41.0165 13.415 40.5596 13.2174C38.6776 12.379 33.915 7.09961 33.915 7.09961C33.915 7.09961 39.339 7.10587 41.9663 7.65892C39.2896 7.13442 34.0908 7.12995 34.0908 7.12995Z",
    fill: "url(#paint16_radial_578_447510)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0531 12.1389C45.892 10.257 44.7058 8.8192 42.8296 7.99076C41.0895 7.21552 34.9103 7.15747 33.9584 7.15334C33.9256 7.1195 33.9199 7.10962 33.9199 7.10962C33.9199 7.10962 41.048 7.12084 42.9144 7.95499C44.7964 8.79331 45.9727 10.2368 45.1379 12.1031C44.8446 12.7602 44.4258 13.1997 43.9297 13.4598C44.3832 13.1716 44.7781 12.7591 45.0531 12.1389Z",
    fill: "url(#paint17_radial_578_447510)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32 6.22717C32 6.22717 33.0935 6.54508 33.9188 7.08374C33.9245 7.09363 32.9201 6.72433 32 6.22717Z",
    fill: "url(#paint18_radial_578_447510)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2274 8.30324C34.6201 8.70934 35.0456 9.14926 35.4866 9.59338C36.9022 11.0174 38.5123 12.5268 39.7071 13.34C40.0168 13.5567 40.298 13.7239 40.545 13.8318C41.5541 14.2776 42.5608 14.5137 43.4728 14.4487C42.4988 14.5891 41.4 14.3534 40.2859 13.8628C40.0389 13.7549 39.7577 13.5876 39.448 13.3709C38.2475 12.5479 36.6531 11.0426 35.2276 9.6243C34.7865 9.18018 34.3553 8.73035 33.9683 8.33414C32.8442 7.16375 32.0329 6.26101 32.0059 6.23706L32.4898 6.45866C32.8129 6.81268 33.442 7.49104 34.2274 8.30324Z",
    fill: "url(#paint19_radial_578_447510)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.227 9.62445C35.4407 9.26372 35.6001 9.10577 35.6001 9.10577L34.2241 7.65892C34.1103 7.89597 34.0221 8.13152 33.9522 8.33013C34.3605 8.7404 34.7859 9.18033 35.227 9.62445Z",
    fill: "url(#paint20_radial_578_447510)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0565 10.3483C37.8275 9.12534 38.5795 8.09789 39.2376 7.29607C39.0987 7.28396 38.9754 7.27602 38.8366 7.26391C36.4106 7.08242 33.9346 7.08813 33.9346 7.08813C33.9346 7.08813 34.6903 7.91741 35.7106 8.97639C36.1105 9.41786 36.5786 9.88597 37.0565 10.3483Z",
    fill: "url(#paint21_radial_578_447510)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5651 27.3565V36.5627C64.5651 38.6129 63.6116 40.4803 62.0702 41.4597L50.144 49.0467C49.1381 49.6866 48.0278 50 46.9044 50C45.8071 50 44.7099 49.6866 43.7171 49.0467L31.7909 41.4597C30.2495 40.4803 29.2959 38.5999 29.2959 36.5627V27.3565H32.862V29.6939C32.862 30.5297 33.2408 31.3132 33.8548 31.7441L45.8986 40.1669C46.5517 40.6239 47.3616 43.6274 48.0016 43.1704L60.0454 31.7311C60.6594 31.3001 61.0382 30.5166 61.0382 29.6808V27.3434L64.5651 27.3565Z",
    fill: "url(#paint22_radial_578_447510)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5649 32.2789V36.5622C64.5649 38.6124 63.6113 40.4797 62.0699 41.4591L50.1437 49.0461C49.1379 49.686 48.0275 49.9994 46.9041 49.9994V46.8915L45.833 42.8172L64.5649 32.2789Z",
    fill: "url(#paint23_radial_578_447510)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5648 27.2911V35.5964C64.5648 37.3462 63.6112 38.9524 62.0698 39.7881L57.6807 42.1779L50.1436 46.2782C48.145 47.3752 45.7284 47.3752 43.7298 46.2782L41.1433 44.8679L36.1273 42.1387L31.8035 39.7881C30.2621 38.9524 29.3086 37.3462 29.3086 35.5964V27.2911H32.8747V29.2891C32.8747 30.0073 33.2535 30.6733 33.8675 31.052L40.5686 35.061L45.9112 38.2603C46.5643 38.6521 47.3742 38.6521 48.0143 38.2603L54.1015 34.617L60.0712 31.052C60.6852 30.6863 61.0639 30.0073 61.0639 29.2891V27.2911H64.5648Z",
    fill: "url(#paint24_radial_578_447510)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5944 35.0477L35.2518 41.6814L31.8163 39.7749C30.2749 38.9391 29.3213 37.3329 29.3213 35.5831V27.2778H32.8874V29.2758C32.8874 29.994 33.2663 30.66 33.8802 31.0387L40.5944 35.0477Z",
    fill: "url(#paint25_radial_578_447510)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0825 39.3308L50.1563 45.8209C48.1577 46.9178 45.7411 46.9178 43.7425 45.8209L31.8163 39.3308C30.2749 38.495 29.3213 36.8889 29.3213 35.139V35.5961C29.3213 37.3459 30.2749 38.9521 31.8163 39.7878L43.7425 46.2779C45.7411 47.3749 48.1577 47.3749 50.1563 46.2779L62.0825 39.7878C63.6239 38.9521 64.5775 37.3459 64.5775 35.5961V35.139C64.5644 36.8889 63.6109 38.495 62.0825 39.3308Z",
    fill: "url(#paint26_radial_578_447510)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5654 27.2909V35.5961C64.5654 37.346 63.6118 38.9521 62.0704 39.7879L58.9745 41.4855L54.1152 34.6037L60.0848 31.0387C60.6988 30.673 61.0776 29.994 61.0776 29.2758V27.2778L64.5654 27.2909Z",
    fill: "url(#paint27_radial_578_447510)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8194 36.0012C76.5059 36.2754 76.1663 36.4974 75.8136 36.6672C74.9253 37.0981 73.9456 37.1895 72.9137 37.0459C68.1588 36.3668 62.6333 30.4775 62.2807 30.0857C62.2676 30.0726 62.2676 30.0726 62.2676 30.0726C65.9251 32.7888 74.1155 33.9379 76.4014 35.0871C76.9892 35.3874 77.1851 35.6878 76.8194 36.0012Z",
    fill: "url(#paint28_radial_578_447510)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8132 36.6799C70.758 39.1349 62.7244 30.5685 62.2803 30.0984C62.646 30.451 71.2282 37.8682 75.8132 36.6799Z",
    fill: "url(#paint29_radial_578_447510)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1924 32.3578C65.1924 32.3578 68.1446 35.296 72.4814 36.4321C72.4814 36.419 68.7846 34.9956 65.1924 32.3578Z",
    fill: "url(#paint30_radial_578_447510)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8188 36.0012C76.5053 36.2754 76.1657 36.4974 75.813 36.6672C74.9248 37.0981 73.945 37.1895 72.9131 37.0459C74.0104 37.0459 75.2121 36.8239 75.2121 36.8239C74.8072 36.8631 74.4806 36.7847 74.4806 36.7847C77.2107 36.2232 76.8188 35.4659 76.3878 35.0741C76.9887 35.3875 77.1846 35.6878 76.8188 36.0012Z",
    fill: "url(#paint31_radial_578_447510)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8972 35.9101C76.8841 35.9362 76.8449 35.9623 76.8057 36.0014C76.4922 36.2757 76.1526 36.4977 75.7999 36.6674C74.9117 37.0984 73.9319 37.1898 72.9 37.0461C68.1452 36.3671 62.6197 30.4777 62.267 30.0859C62.2539 30.0729 62.2539 30.0729 62.2539 30.0729C62.489 30.2426 62.7373 30.4124 63.0116 30.5691C66.9434 32.9197 74.2455 34.0035 76.3878 35.0873C76.9233 35.3485 77.1454 35.6228 76.8972 35.9101Z",
    fill: "url(#paint32_radial_578_447510)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8973 35.9095C69.0205 34.9693 63.0247 30.5816 63.0247 30.5816C63.0247 30.5686 63.0117 30.5686 63.0117 30.5686C66.9436 32.9191 74.2456 34.0029 76.3879 35.0868C76.9235 35.348 77.1455 35.6222 76.8973 35.9095Z",
    fill: "url(#paint33_radial_578_447510)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5594 32.3183C83.4941 32.5925 83.4157 32.8406 83.3112 33.0756C82.8409 34.1595 81.9657 34.8255 80.8554 35.165C74.729 37.0715 60.9609 29.6021 60.9609 29.6021C60.9609 29.6021 60.961 29.6021 60.974 29.6021C70.9278 31.9918 78.6609 31.5869 81.9135 31.7567C81.9135 31.7567 81.9135 31.7567 81.9265 31.7567C83.063 31.8351 83.6508 31.9526 83.5594 32.3183Z",
    fill: "url(#paint34_radial_578_447510)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3116 33.0626C80.2418 40.0489 60.9482 29.6021 60.9482 29.6021C60.9482 29.6021 60.9483 29.6021 60.9613 29.6021C61.3793 29.7979 78.8441 37.6853 83.3116 33.0626Z",
    fill: "url(#paint35_radial_578_447510)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1191 32.3965C68.1191 32.3965 75.2252 35.4521 80.7899 34.3813C80.803 34.3552 75.8653 35.0604 68.1191 32.3965Z",
    fill: "url(#paint36_radial_578_447510)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5595 32.3181C83.4942 32.5924 83.4158 32.8405 83.3113 33.0755C82.841 34.1594 81.9658 34.8254 80.8555 35.1649C82.1225 34.5511 82.7365 33.7807 82.7888 33.7284C82.1356 34.0549 81.2865 34.2116 81.182 34.2247C83.1153 33.5587 83.4288 32.6707 83.3635 32.2136C83.3243 31.9394 82.5275 31.8088 81.9136 31.7566C83.0631 31.8349 83.6509 31.9525 83.5595 32.3181Z",
    fill: "url(#paint37_radial_578_447510)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5594 32.318C83.4941 32.5922 83.4157 32.8403 83.3112 33.0754C82.8409 34.1592 81.9657 34.8252 80.8554 35.1647C77.5375 36.1964 71.9466 34.4726 67.5314 32.6706C63.8216 31.1558 60.9609 29.6149 60.9609 29.6149C60.9609 29.6149 60.961 29.6149 60.974 29.6149C70.9278 32.0046 78.6609 31.5998 81.9135 31.7695C81.9135 31.7695 81.9135 31.7695 81.9265 31.7695H81.9396C83.063 31.8348 83.6508 31.9654 83.5594 32.318Z",
    fill: "url(#paint38_radial_578_447510)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9265 31.7699C79.6798 32.3314 75.0948 32.5404 67.44 32.2009C63.7302 30.6861 60.9609 29.6283 60.9609 29.6283C60.9609 29.6283 60.961 29.6283 60.974 29.6283C70.9278 32.018 78.6609 31.6132 81.9135 31.783C81.9135 31.7699 81.9135 31.7699 81.9265 31.7699Z",
    fill: "url(#paint39_radial_578_447510)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1242 30.3598C60.1111 30.3598 60.1111 30.3467 60.098 30.3467C60.085 30.3337 60.085 30.3337 60.085 30.3337C78.229 28.3618 89.7373 20.9576 90.0769 23.6607C90.103 23.8697 90.1291 24.0656 90.1291 24.2614C90.8737 36.6801 61.5219 30.6471 60.1242 30.3598Z",
    fill: "url(#paint40_radial_578_447510)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M60.124 30.3597C61.1298 30.5295 76.4132 32.9192 83.8459 29.9418C88.3394 28.1528 89.7371 25.8545 90.129 24.2614C90.8735 36.68 61.5217 30.647 60.124 30.3597Z",
    fill: "url(#paint41_radial_578_447510)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9855 26.1419C87.7387 36.0272 61.4435 30.634 60.1242 30.3468C60.1111 30.3468 60.1111 30.3337 60.098 30.3337C60.085 30.3206 60.085 30.3206 60.085 30.3206C60.3723 30.2945 60.6597 30.2554 60.9602 30.2292C71.9459 28.9103 80.4105 25.6588 85.3221 24.0395C85.5442 23.9612 85.7531 23.8959 85.9621 23.8306C88.5355 22.9948 89.9724 22.7336 90.09 23.6608C90.1161 23.8697 90.1422 24.0656 90.1422 24.2615C90.1683 24.9536 90.1031 25.5804 89.9855 26.1419Z",
    fill: "url(#paint42_radial_578_447510)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M88.836 26.5859C88.836 26.5859 85.7793 30.8169 75.6035 31.2609C75.6166 31.2478 85.0217 31.7571 88.836 26.5859Z",
    fill: "url(#paint43_radial_578_447510)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9856 26.142C89.9986 25.6719 90.0639 25.0451 90.0639 25.0451C89.672 25.8678 88.3788 27.2259 88.3004 27.2912C89.4238 25.7242 90.2729 24.1964 89.4238 23.5695C88.5878 22.9558 85.4136 24.0135 85.2568 24.0657C85.2699 24.0527 85.2699 24.0527 85.296 24.0397C88.2743 23.0472 89.9333 22.6555 90.077 23.6479C90.1031 23.8568 90.1292 24.0527 90.1292 24.2486C90.1684 24.9537 90.1031 25.5805 89.9856 26.142Z",
    fill: "url(#paint44_radial_578_447510)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9229 23.8435C84.7995 24.8229 80.7108 28.1006 75.1722 29.6546C70.0125 31.1171 63.4028 30.8559 60.9209 30.2552C71.9066 28.9363 80.3712 25.6847 85.2828 24.0655C85.5049 23.9871 85.7269 23.9088 85.9229 23.8435Z",
    fill: "url(#paint45_radial_578_447510)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7889 30.5947C61.5871 30.7253 60.7381 30.7776 60.3723 30.8037C60.307 30.8167 60.2417 30.8167 60.1895 30.8167C65.6888 29.2236 70.5612 26.6119 74.676 23.9218C83.7937 17.9279 89.2017 11.477 89.6327 14.7286C91.2133 26.5857 70.2608 29.8243 62.7889 30.5947Z",
    fill: "url(#paint46_radial_578_447510)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2031 30.8165C89.2545 27.0556 89.6333 14.7023 89.6333 14.7023C91.5666 29.145 60.2031 30.8165 60.2031 30.8165Z",
    fill: "url(#paint47_radial_578_447510)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6595 17.079C88.3793 27.0296 69.765 29.8895 62.8026 30.6077C61.6008 30.7383 60.7517 30.7905 60.386 30.8166C60.3207 30.8297 60.2554 30.8297 60.2031 30.8297C65.7025 29.2366 70.5749 26.6248 74.6896 23.9348C78.3211 21.545 81.3646 19.09 83.742 17.1965C83.7551 17.1835 83.7551 17.1835 83.7551 17.1835C87.3212 14.3368 89.3851 12.7958 89.6464 14.7285C89.7509 15.5381 89.7509 16.3347 89.6595 17.079Z",
    fill: "url(#paint48_radial_578_447510)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1396 27.108C76.1396 27.108 85.3096 24.6791 88.5753 17.8887C88.5753 17.8887 86.211 23.1121 76.1396 27.108Z",
    fill: "url(#paint49_radial_578_447510)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6589 14.6631C89.6458 14.4934 89.6196 14.3759 89.5674 14.2845C89.0841 12.9525 87.0724 14.4673 83.7676 17.1051C85.1783 16.0866 87.2423 14.6762 88.222 14.4673C88.7053 14.3628 89.0579 14.5587 89.28 14.9635C89.2931 15.5773 89.1233 16.635 88.3134 18.2935C88.3134 18.2935 89.1625 16.7264 89.5152 15.5381C89.6327 15.956 89.685 16.4652 89.6589 17.0268C89.7764 16.2694 89.7764 15.4858 89.6589 14.6631Z",
    fill: "url(#paint50_radial_578_447510)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4799 19.4041C74.4668 19.4171 74.4668 19.4171 74.4537 19.4302C74.1272 19.848 73.7484 20.2659 73.3304 20.6707C68.8891 24.9931 59.8628 28.6756 59.8628 28.6756C59.8628 28.6756 56.1007 28.4275 61.7829 25.7375C66.0414 23.7265 71.5016 18.1374 74.1272 16.1394C74.8456 15.604 75.3421 15.3167 75.5511 15.4473C75.6033 15.4734 75.6425 15.5257 75.6555 15.604C75.747 15.9566 75.76 16.3222 75.7209 16.7009C75.6294 17.602 75.1722 18.5161 74.4799 19.4041Z",
    fill: "url(#paint51_radial_578_447510)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M73.332 20.6697C74.991 18.5412 75.4612 16.6607 75.5527 15.4332C75.6049 15.4593 75.6441 15.5116 75.6572 15.59C76.0621 17.2614 75.0432 19.0243 73.332 20.6697Z",
    fill: "url(#paint52_radial_578_447510)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7219 16.7007C75.6566 16.4918 75.6044 16.3742 75.6044 16.3742C75.3431 17.3144 74.9251 18.3853 74.5201 19.2732C75.1341 17.5887 75.4606 15.7735 75.2386 15.7082C75.0165 15.656 74.4026 15.9694 74.1152 16.1392C74.8337 15.6038 75.3301 15.3165 75.5391 15.4471C75.5913 15.4732 75.6305 15.5254 75.6435 15.6038C75.748 15.9694 75.7742 16.335 75.7219 16.7007Z",
    fill: "url(#paint53_radial_578_447510)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7209 16.7008C75.7078 16.8314 75.6947 16.9358 75.6686 17.0664C75.4988 17.8499 75.0808 18.6334 74.4799 19.4169C74.4668 19.43 74.4668 19.43 74.4538 19.4431C74.1272 19.861 73.7484 20.2788 73.3304 20.6837C68.8891 25.006 59.8628 28.6885 59.8628 28.6885C59.8628 28.6885 56.1007 28.4404 61.7829 25.7503C62.5406 25.3978 63.3244 24.9277 64.1212 24.3923C67.8702 21.885 71.9458 17.8108 74.1142 16.1654C74.8326 15.63 75.329 15.3427 75.538 15.4733C75.5902 15.4994 75.6294 15.5516 75.6425 15.63C75.747 15.9695 75.7731 16.3352 75.7209 16.7008Z",
    fill: "url(#paint54_radial_578_447510)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6686 17.0662C75.4988 17.8497 75.0808 18.6332 74.4799 19.4167C74.4668 19.4298 74.4668 19.4298 74.4537 19.4428C74.1272 19.8607 73.7484 20.2786 73.3304 20.6834C68.8891 25.0058 59.8628 28.6883 59.8628 28.6883C59.8628 28.6883 56.1007 28.4402 61.7829 25.7501C62.5406 25.3975 63.3244 24.9274 64.1212 24.392C66.6031 23.2559 71.1881 20.9184 75.6686 17.0662Z",
    fill: "url(#paint55_radial_578_447510)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8283 19.8745C76.2172 26.456 60.7901 28.8979 60.7901 28.8979C60.7901 28.8979 59.7059 28.2058 59.523 27.344C59.3924 26.691 59.7581 25.9467 61.5347 25.333C69.5813 22.5384 74.5451 19.6133 77.5887 17.5501C77.6409 17.5239 77.6801 17.4847 77.7193 17.4586C78.3855 17.0016 78.9603 16.5837 79.4436 16.2311C81.3377 14.86 81.9647 14.3507 82.0562 15.3693C82.0562 15.3954 82.0562 15.4215 82.0692 15.4476C82.226 17.093 81.7427 18.5555 80.8283 19.8745Z",
    fill: "url(#paint56_radial_578_447510)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7896 28.8979C60.7896 28.8979 59.7053 28.2058 59.5225 27.344C62.7881 26.8739 74.8842 24.9673 79.3124 20.4882C81.1673 18.6078 81.8989 16.8841 82.0817 15.4607C82.9439 25.3852 60.7896 28.8979 60.7896 28.8979Z",
    fill: "url(#paint57_radial_578_447510)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8283 19.8736C79.7833 21.3622 78.1896 22.629 76.3478 23.7128C70.0385 27.4345 60.7902 28.884 60.7902 28.884C60.7902 28.884 59.7059 28.1919 59.523 27.33C59.4839 27.1472 59.4839 26.9644 59.5361 26.7816C59.6929 26.2854 60.2415 25.763 61.5216 25.319C69.5682 22.5245 74.5321 19.5993 77.5757 17.5361C77.628 17.51 77.6671 17.4708 77.7063 17.4447C78.3725 16.9877 78.9472 16.5698 79.4306 16.2172C81.3246 14.846 81.9517 14.3368 82.0431 15.3554C82.0431 15.3815 82.0431 15.4075 82.0562 15.4337C82.226 17.0921 81.7427 18.5547 80.8283 19.8736Z",
    fill: "url(#paint58_radial_578_447510)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3478 23.7133C70.0385 27.435 60.7902 28.8844 60.7902 28.8844C60.7902 28.8844 59.7059 28.1923 59.523 27.3305C59.4839 27.1477 59.4839 26.9649 59.5361 26.7821C60.6334 26.547 73.5393 23.8439 77.2099 21.6631C77.223 21.6631 77.2491 22.5511 76.3478 23.7133Z",
    fill: "url(#paint59_radial_578_447510)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6253 17.2234C81.6253 17.2234 79.9402 20.6839 75.7471 22.9561C75.7471 22.9561 79.9271 21.2193 81.6253 17.2234Z",
    fill: "url(#paint60_radial_578_447510)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8279 19.8745C81.9121 17.6937 81.9121 16.7665 81.9121 16.7665C81.4418 18.2422 80.5274 19.1432 80.5274 19.1432C81.5463 17.5762 82.2909 15.4215 81.4418 15.2387C81.0499 15.1603 80.3184 15.6957 79.4824 16.2311C81.3765 14.86 82.0035 14.3507 82.095 15.3693C82.095 15.3954 82.095 15.4215 82.108 15.4476C82.2256 17.093 81.7423 18.5555 80.8279 19.8745Z",
    fill: "url(#paint61_radial_578_447510)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8657 25.8416C70.1167 29.5763 57.8378 31.0781 57.8378 31.0781C56.7928 31.1695 55.8654 30.843 55.4865 30.2946C54.8334 29.3674 55.7609 27.8526 60.3981 26.9907C63.6507 26.39 66.9294 25.4498 69.5289 24.7316C69.5289 24.7316 69.5289 24.7316 69.542 24.7316C72.7946 23.8175 75.0283 23.2299 74.8977 24.0134C74.8063 24.6663 74.4274 25.2801 73.8657 25.8416Z",
    fill: "url(#paint62_radial_578_447510)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8386 31.0652C56.7936 31.1566 55.8661 30.8301 55.4873 30.2817C73.0305 29.25 74.8985 24.0005 74.8985 24.0005C74.1016 29.0933 57.8386 31.0652 57.8386 31.0652Z",
    fill: "url(#paint63_radial_578_447510)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0156 30.1248C57.0156 30.1248 68.5761 30.1118 73.1611 25.5935C73.1481 25.5805 70.3788 29.0801 57.0156 30.1248Z",
    fill: "url(#paint64_radial_578_447510)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8378 31.0655C56.7928 31.1569 55.8654 30.8305 55.4865 30.282C54.8334 29.3549 55.7609 27.8401 60.3981 26.9782C67.7393 25.6332 75.1067 22.5905 74.8846 23.9878C74.1009 29.0937 57.8378 31.0655 57.8378 31.0655Z",
    fill: "url(#paint65_radial_578_447510)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8657 25.8417C74.2576 25.2541 74.5188 24.784 74.5188 24.784C73.7612 25.5675 71.6843 26.7428 71.2924 26.9648C73.2387 25.8417 75.3157 24.0135 74.2968 23.8829C73.6437 23.8046 71.2401 24.3269 69.542 24.7187C72.7946 23.8046 75.0283 23.2169 74.8977 24.0004C74.8063 24.6664 74.4274 25.2802 73.8657 25.8417Z",
    fill: "url(#paint66_radial_578_447510)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7725 15.6558L49.0598 16.2565L51.9858 22.2242L62.0833 17.2881C65.7278 15.4991 68.5232 12.352 69.8425 8.49973L70.8353 5.60071L70.5479 5L48.7725 15.6558Z",
    fill: "url(#paint67_radial_578_447510)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7725 15.6563L70.5479 5.01355L69.5551 7.91257C68.2358 11.7518 65.4404 14.9119 61.7959 16.7009L51.6985 21.637L48.7725 15.6563Z",
    fill: "url(#paint68_radial_578_447510)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7725 15.6563L70.5479 5.01355L69.5551 7.91257C68.2358 11.7518 65.4404 14.9119 61.7959 16.7009L51.6985 21.637L48.7725 15.6563Z",
    fill: "url(#paint69_radial_578_447510)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5352 5.01331L48.7598 15.656L48.8382 15.8127L70.2348 5.36591L69.242 8.26487C68.5758 10.2106 67.5308 11.9866 66.1854 13.4883C67.6745 11.9213 68.8371 10.0278 69.5425 7.92533L70.4961 5.20918L70.8357 5.64009L70.5352 5.01331Z",
    fill: "url(#paint70_radial_578_447510)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2932 16.374L51.6602 21.5713L51.6863 21.6235L61.7837 16.6874C62.3585 16.4131 62.9072 16.0867 63.4427 15.7472C63.077 15.9692 62.6851 16.1781 62.2932 16.374Z",
    fill: "url(#paint71_radial_578_447510)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4893 16.3479C62.4893 16.3479 65.6896 14.8071 67.8841 11.3074C67.8841 11.3074 66.3427 13.9321 62.4893 16.3479Z",
    fill: "url(#paint72_radial_578_447510)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7257 17.2231C61.9274 13.7626 64.4616 9.70132 66.225 7.14185L60.2554 10.067C59.1973 13.3447 56.4803 17.5495 54.6123 20.2265L60.7257 17.2231Z",
    fill: "url(#paint73_radial_578_447510)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9553 8.48682L65.4923 10.994C64.2383 13.1226 62.4356 14.8202 60.2542 15.878L51.1364 20.3309L49.5166 17.014L66.9553 8.48682Z",
    fill: "url(#paint74_radial_578_447510)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0343 8.38245L65.4798 10.7722C64.1605 12.8093 62.3056 14.4547 60.111 15.5255L50.9149 20.0176L49.4258 16.975L67.0343 8.38245Z",
    fill: "url(#paint75_radial_578_447510)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M66.825 8.72205L65.3098 11.1118C64.0296 13.1359 62.2009 14.7551 60.0455 15.8129L50.9931 20.2266L49.5039 17.184L66.825 8.72205Z",
    fill: "url(#paint76_radial_578_447510)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3145 17.0137L66.1465 9.27002L66.0027 9.47897C64.9839 11.0591 63.5469 12.3257 61.8488 13.1614L50.9807 18.4632L50.3145 17.0137Z",
    fill: "url(#paint77_radial_578_447510)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4075 9.75327C66.4075 9.75327 65.1926 11.8557 64.2129 12.9396C64.2129 12.9396 65.7282 11.8165 66.6948 12.4564C66.6948 12.4564 68.6412 9.64881 69.1506 8.05566C69.1506 8.06872 68.0142 9.38763 66.4075 9.75327Z",
    fill: "url(#paint78_radial_578_447510)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2158 16.7791L51.3334 17.3406L52.5352 22.9427L61.9925 20.9187C65.415 20.1874 68.3933 18.1241 70.3004 15.186L71.7242 12.9791L71.6067 12.4176L51.2158 16.7791Z",
    fill: "url(#paint79_radial_578_447510)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2158 16.7793L71.6067 12.3916L70.1829 14.5985C68.2757 17.5367 65.2974 19.5999 61.875 20.3312L52.4176 22.3552L51.2158 16.7793Z",
    fill: "url(#paint80_radial_578_447510)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2158 16.7793L71.6067 12.3916L70.1829 14.5985C68.2757 17.5367 65.2974 19.5999 61.875 20.3312L52.4176 22.3552L51.2158 16.7793Z",
    fill: "url(#paint81_radial_578_447510)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6067 12.4176L51.2158 16.8052L51.242 16.9489L71.2801 12.6396L69.8563 14.8464C68.9027 16.3351 67.6487 17.5887 66.2248 18.5681C67.7924 17.5626 69.1509 16.2176 70.1829 14.6245L71.5414 12.5482L71.7373 12.9791L71.6067 12.4176Z",
    fill: "url(#paint82_radial_578_447510)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3711 20.1876L52.4043 22.3292L52.4174 22.3814L61.8747 20.3573C62.4103 20.2398 62.9459 20.0961 63.4553 19.9133C63.1026 20.0047 62.7369 20.1092 62.3711 20.1876Z",
    fill: "url(#paint83_radial_578_447510)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5283 20.2004C62.5283 20.2004 65.5066 19.5867 68.08 17.1056C68.08 17.1186 66.2642 18.9729 62.5283 20.2004Z",
    fill: "url(#paint84_radial_578_447510)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8827 20.5528C62.5939 17.9019 65.5592 15.0421 67.5578 13.2661L61.9539 14.4675C60.3864 16.9878 57.2513 19.939 55.1221 21.7802L60.8827 20.5528Z",
    fill: "url(#paint85_radial_578_447510)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8967 14.5594L66.1463 16.3484C64.6572 17.8763 62.8023 18.908 60.7645 19.3389L52.2346 21.1671L51.5684 18.0591L67.8967 14.5594Z",
    fill: "url(#paint86_radial_578_447510)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9754 14.4945L66.1858 16.179C64.6574 17.6024 62.7634 18.5949 60.7256 19.0389L52.1042 20.8932L51.4902 18.0464L67.9754 14.4945Z",
    fill: "url(#paint87_radial_578_447510)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7532 14.7424L65.9897 16.4139C64.4875 17.8373 62.6457 18.8167 60.6209 19.2476L52.1433 21.0758L51.5293 18.2291L67.7532 14.7424Z",
    fill: "url(#paint88_radial_578_447510)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2217 18.2421L67.0478 15.0558L66.878 15.2125C65.6893 16.3225 64.2263 17.0799 62.6457 17.4194L52.4699 19.6002L52.2217 18.2421Z",
    fill: "url(#paint89_radial_578_447510)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1786 15.5253C67.1786 15.5253 65.7286 17.0271 64.6836 17.7322C64.6836 17.7322 66.1858 17.1054 66.852 17.8497C66.852 17.8497 69.0596 15.904 69.8172 14.6896C69.8172 14.6765 68.5893 15.5253 67.1786 15.5253Z",
    fill: "url(#paint90_radial_578_447510)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3076 19.4172L49.3207 19.9918L49.3729 25.7114L59.0524 25.62C62.5532 25.5939 65.8842 24.1705 68.34 21.6764L70.1818 19.7959L70.1687 19.2213L49.3076 19.4172Z",
    fill: "url(#paint91_radial_578_447510)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3076 19.4162L70.1557 19.2334L68.3138 21.1138C65.858 23.608 62.5271 25.0183 59.0263 25.0575L49.3468 25.149L49.3076 19.4162Z",
    fill: "url(#paint92_radial_578_447510)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3076 19.4162L70.1557 19.2334L68.3138 21.1138C65.858 23.608 62.5271 25.0183 59.0263 25.0575L49.3468 25.149L49.3076 19.4162Z",
    fill: "url(#paint93_radial_578_447510)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1557 19.2334L49.3076 19.4162V19.5599L69.7899 19.3771L67.9481 21.2575C66.7071 22.5242 65.2441 23.5036 63.6374 24.1696C65.3747 23.5036 66.9814 22.4589 68.3138 21.1008L70.0643 19.3379L70.1557 19.795V19.2334Z",
    fill: "url(#paint94_radial_578_447510)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5492 24.9928L49.3604 25.0843V25.1365L59.0397 25.045C59.5884 25.032 60.137 24.9928 60.6857 24.9275C60.2938 24.9667 59.9281 24.9928 59.5492 24.9928Z",
    fill: "url(#paint95_radial_578_447510)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7061 25.0452C59.7061 25.0452 62.7627 25.0322 65.7671 23.1387C65.7541 23.1387 63.5987 24.5882 59.7061 25.0452Z",
    fill: "url(#paint96_radial_578_447510)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0208 25.0711C60.2284 22.825 63.7161 20.6181 66.0282 19.2861L60.3068 19.3384C58.2559 21.4931 54.5984 23.7522 52.1426 25.1233L58.0208 25.0711Z",
    fill: "url(#paint97_radial_578_447510)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0803 20.592L64.0033 21.9893C62.2398 23.1907 60.2151 23.8176 58.1381 23.8437L49.3992 23.922L49.373 20.7357L66.0803 20.592Z",
    fill: "url(#paint98_radial_578_447510)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1852 20.5525L64.0952 21.8322C62.3187 22.9291 60.2678 23.5168 58.1648 23.5298L49.3474 23.6082L49.3213 20.6961L66.1852 20.5525Z",
    fill: "url(#paint99_radial_578_447510)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8978 20.736L63.847 22.0157C62.0966 23.1127 60.085 23.7003 58.021 23.7133L49.3474 23.7916L49.3213 20.8796L65.8978 20.736Z",
    fill: "url(#paint100_radial_578_447510)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9998 21.0494L65.1656 20.9188L64.9696 21.0364C63.585 21.8852 61.9913 22.3422 60.3846 22.3553L49.9736 22.4467L49.9998 21.0494Z",
    fill: "url(#paint101_radial_578_447510)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1916 21.3883C65.1916 21.3883 63.4673 22.5766 62.3047 23.0468C62.3047 23.0468 63.8983 22.7333 64.4078 23.5952C64.4078 23.5952 66.955 22.1327 67.9478 21.101C67.9478 21.088 66.5631 21.6756 65.1916 21.3883Z",
    fill: "url(#paint102_radial_578_447510)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3177 36.0011C17.6312 36.2753 17.9709 36.4973 18.3235 36.6671C19.2118 37.098 20.1915 37.1894 21.2234 37.0458C25.9782 36.3667 31.5038 30.4773 31.8565 30.0856C31.8696 30.0725 31.8695 30.0725 31.8695 30.0725C28.212 32.7887 20.0217 33.9378 17.7357 35.087C17.161 35.3873 16.9519 35.6877 17.3177 36.0011Z",
    fill: "url(#paint103_radial_578_447510)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3242 36.6796C23.3795 39.1346 31.413 30.5683 31.8572 30.0981C31.4914 30.4507 22.9092 37.868 18.3242 36.6796Z",
    fill: "url(#paint104_radial_578_447510)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9442 32.3577C28.9442 32.3577 25.9921 35.2959 21.6553 36.432C21.6553 36.4189 25.365 34.9955 28.9442 32.3577Z",
    fill: "url(#paint105_radial_578_447510)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3182 36.0011C17.6317 36.2753 17.9713 36.4973 18.324 36.6671C19.2123 37.098 20.1919 37.1894 21.2239 37.0458C20.1266 37.0458 18.9249 36.8238 18.9249 36.8238C19.3299 36.863 19.6564 36.7846 19.6564 36.7846C16.9263 36.2231 17.3182 35.4657 17.7493 35.074C17.1614 35.3874 16.9524 35.6877 17.3182 36.0011Z",
    fill: "url(#paint106_radial_578_447510)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2402 35.9096C17.2533 35.9357 17.2925 35.9618 17.3317 36.001C17.6452 36.2752 17.9849 36.4972 18.3376 36.667C19.2258 37.0979 20.2055 37.1893 21.2374 37.0456C25.9923 36.3666 31.5178 30.4772 31.8704 30.0855C31.8835 30.0724 31.8835 30.0724 31.8835 30.0724C31.6484 30.2421 31.4002 30.4119 31.1259 30.5687C27.194 32.9192 19.892 34.003 17.7497 35.0869C17.2011 35.348 16.9921 35.6223 17.2402 35.9096Z",
    fill: "url(#paint107_radial_578_447510)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2402 35.9093C25.117 34.9691 31.1128 30.5814 31.1128 30.5814C31.1128 30.5683 31.1259 30.5684 31.1259 30.5684C27.194 32.9189 19.892 34.0027 17.7497 35.0866C17.2011 35.3477 16.9921 35.622 17.2402 35.9093Z",
    fill: "url(#paint108_radial_578_447510)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5774 32.3181C10.6427 32.5924 10.7211 32.8405 10.8256 33.0755C11.2959 34.1594 12.1711 34.8254 13.2814 35.1649C19.4078 37.0714 33.1758 29.6019 33.1758 29.6019C33.1758 29.6019 33.1759 29.6019 33.1628 29.6019C23.2091 31.9916 15.4759 31.5868 12.2233 31.7566C12.2233 31.7566 12.2233 31.7566 12.2102 31.7566C11.0738 31.8349 10.499 31.9525 10.5774 32.3181Z",
    fill: "url(#paint109_radial_578_447510)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8262 33.0623C13.8959 40.0486 33.1894 29.6018 33.1894 29.6018C33.1894 29.6018 33.1894 29.6018 33.1764 29.6018C32.7584 29.7977 15.3067 37.685 10.8262 33.0623Z",
    fill: "url(#paint110_radial_578_447510)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0165 32.3962C26.0165 32.3962 18.9104 35.4519 13.3457 34.3811C13.3327 34.355 18.2834 35.0602 26.0165 32.3962Z",
    fill: "url(#paint111_radial_578_447510)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5774 32.318C10.6427 32.5923 10.7211 32.8403 10.8256 33.0754C11.2959 34.1593 12.1711 34.8252 13.2814 35.1648C12.0143 34.551 11.4004 33.7806 11.3481 33.7283C12.0013 34.0548 12.8503 34.2115 12.9548 34.2246C11.0215 33.5586 10.708 32.6706 10.7733 32.2135C10.8125 31.9393 11.6093 31.8087 12.2233 31.7565C11.0738 31.8348 10.499 31.9524 10.5774 32.318Z",
    fill: "url(#paint112_radial_578_447510)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5774 32.3179C10.6427 32.5921 10.7211 32.8402 10.8256 33.0753C11.2959 34.1591 12.1711 34.8251 13.2814 35.1646C16.5993 36.1962 22.1901 34.4725 26.6053 32.6704C30.3151 31.1556 33.1758 29.6147 33.1758 29.6147C33.1758 29.6147 33.1759 29.6147 33.1628 29.6147C23.2091 32.0045 15.4759 31.5996 12.2233 31.7694C12.2233 31.7694 12.2233 31.7694 12.2102 31.7694H12.1972C11.0738 31.8347 10.499 31.9653 10.5774 32.3179Z",
    fill: "url(#paint113_radial_578_447510)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2109 31.7696C14.4577 32.3312 19.0428 32.5401 26.6975 32.2006C30.4073 30.6858 33.1765 29.6281 33.1765 29.6281C33.1765 29.6281 33.1766 29.6281 33.1635 29.6281C23.2098 32.0178 15.4766 31.613 12.224 31.7827C12.2371 31.7697 12.2371 31.7696 12.2109 31.7696Z",
    fill: "url(#paint114_radial_578_447510)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0242 30.3597C34.0373 30.3597 34.0373 30.3466 34.0504 30.3466C34.0635 30.3336 34.0635 30.3335 34.0635 30.3335C15.9194 28.3617 4.41117 20.9575 4.07154 23.6606C4.04541 23.8696 4.0193 24.0654 4.0193 24.2613C3.26166 36.68 32.6135 30.647 34.0242 30.3597Z",
    fill: "url(#paint115_radial_578_447510)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0252 30.3596C33.0194 30.5294 17.7361 32.919 10.3034 29.9417C5.80988 28.1527 4.41216 25.8544 4.02028 24.2612C3.26264 36.6799 32.6144 30.6469 34.0252 30.3596Z",
    fill: "url(#paint116_radial_578_447510)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16331 26.1418C6.41009 36.0271 32.7052 30.6339 34.0246 30.3466C34.0376 30.3466 34.0376 30.3336 34.0507 30.3336C34.0638 30.3205 34.0638 30.3205 34.0638 30.3205C33.7764 30.2944 33.489 30.2552 33.1886 30.2291C22.2028 28.9102 13.7382 25.6586 8.82665 24.0394C8.60458 23.961 8.39559 23.8957 8.18659 23.8304C5.61324 22.9947 4.17633 22.7335 4.05877 23.6606C4.03264 23.8696 4.00653 24.0655 4.00653 24.2613C3.9804 24.9534 4.03268 25.5802 4.16331 26.1418Z",
    fill: "url(#paint117_radial_578_447510)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28711 26.5858C5.28711 26.5858 8.34382 30.8168 18.5196 31.2607C18.5327 31.2477 9.11448 31.757 5.28711 26.5858Z",
    fill: "url(#paint118_radial_578_447510)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16326 26.1419C4.1502 25.6718 4.08488 25.045 4.08488 25.045C4.47676 25.8677 5.76996 27.2258 5.84834 27.2911C4.72495 25.7241 3.87586 24.1962 4.72493 23.5694C5.56095 22.9557 8.73516 24.0134 8.89192 24.0656C8.87885 24.0526 8.87888 24.0526 8.85275 24.0395C5.87446 23.0471 4.21549 22.6553 4.0718 23.6478C4.04567 23.8567 4.01956 24.0526 4.01956 24.2484C3.98037 24.9536 4.03264 25.5804 4.16326 26.1419Z",
    fill: "url(#paint119_radial_578_447510)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21289 23.8434C9.33628 24.8228 13.4249 28.1005 18.9635 29.6544C24.1232 31.117 30.7329 30.8558 33.2149 30.2551C22.2291 28.9362 13.7645 25.6846 8.85295 24.0653C8.63088 23.987 8.42189 23.9087 8.21289 23.8434Z",
    fill: "url(#paint120_radial_578_447510)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3345 30.5946C32.5363 30.7252 33.3853 30.7774 33.7511 30.8035C33.8164 30.8166 33.8817 30.8166 33.934 30.8166C28.4346 29.2235 23.5622 26.6117 19.4475 23.9217C10.3297 17.9278 4.92176 11.4769 4.49069 14.7285C2.92317 26.5856 23.8626 29.8241 31.3345 30.5946Z",
    fill: "url(#paint121_radial_578_447510)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9339 30.8163C4.88254 27.0554 4.50369 14.702 4.50369 14.702C2.58347 29.1448 33.9339 30.8163 33.9339 30.8163Z",
    fill: "url(#paint122_radial_578_447510)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4909 17.0789C5.77104 27.0295 24.3853 29.8893 31.3477 30.6076C32.5495 30.7381 33.3986 30.7904 33.7643 30.8165C33.8296 30.8296 33.895 30.8296 33.9472 30.8296C28.4479 29.2364 23.5754 26.6247 19.4607 23.9346C15.8293 21.5449 12.7857 19.0899 10.4083 17.1964C10.3952 17.1834 10.3952 17.1834 10.3952 17.1834C6.82908 14.3366 4.76517 12.7957 4.50391 14.7284C4.38635 15.538 4.3864 16.3346 4.4909 17.0789Z",
    fill: "url(#paint123_radial_578_447510)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9972 27.1079C17.9972 27.1079 8.82719 24.679 5.56152 17.8885C5.56152 17.8885 7.93896 23.112 17.9972 27.1079Z",
    fill: "url(#paint124_radial_578_447510)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47681 14.6631C4.48988 14.4934 4.51596 14.3759 4.56821 14.2845C5.05153 12.9525 7.06324 14.4673 10.3681 17.1051C8.95733 16.0866 6.89341 14.6762 5.91371 14.4673C5.43039 14.3628 5.07768 14.5587 4.85562 14.9635C4.84256 15.5773 5.01236 16.635 5.82224 18.2935C5.82224 18.2935 4.97321 16.7264 4.62052 15.5381C4.50295 15.956 4.45069 16.4652 4.47681 17.0268C4.37231 16.2694 4.37231 15.4858 4.47681 14.6631Z",
    fill: "url(#paint125_radial_578_447510)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M19.668 19.4037C19.6811 19.4168 19.6811 19.4167 19.6942 19.4298C20.0208 19.8477 20.3996 20.2655 20.8176 20.6703C25.2589 24.9927 34.2852 28.6753 34.2852 28.6753C34.2852 28.6753 38.0473 28.4272 32.365 25.7371C28.1066 23.7261 22.6464 18.137 20.0208 16.1391C19.3023 15.6037 18.8059 15.3163 18.5969 15.4469C18.5447 15.4731 18.5055 15.5253 18.4924 15.6037C18.401 15.9562 18.3879 16.3219 18.4271 16.7006C18.5055 17.6016 18.9626 18.5157 19.668 19.4037Z",
    fill: "url(#paint126_radial_578_447510)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8047 20.6696C19.1457 18.5411 18.6755 16.6606 18.584 15.4331C18.5318 15.4592 18.4925 15.5115 18.4795 15.5898C18.0745 17.2613 19.1065 19.0242 20.8047 20.6696Z",
    fill: "url(#paint127_radial_578_447510)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4139 16.7006C18.4792 16.4916 18.5315 16.3741 18.5315 16.3741C18.7927 17.3143 19.2107 18.3851 19.6157 19.2731C19.0017 17.5886 18.6752 15.7734 18.8972 15.7081C19.1193 15.6559 19.7332 15.9693 20.0206 16.1391C19.3022 15.6037 18.8058 15.3163 18.5968 15.4469C18.5445 15.4731 18.5053 15.5253 18.4923 15.6037C18.3878 15.9693 18.3747 16.3349 18.4139 16.7006Z",
    fill: "url(#paint128_radial_578_447510)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4139 16.7007C18.4269 16.8313 18.44 16.9357 18.4662 17.0663C18.636 17.8498 19.0539 18.6333 19.6548 19.4168C19.6679 19.4299 19.6679 19.4299 19.681 19.443C20.0075 19.8608 20.3864 20.2787 20.8044 20.6835C25.2457 25.0059 34.272 28.6884 34.272 28.6884C34.272 28.6884 38.034 28.4403 32.3518 25.7502C31.5941 25.3976 30.8104 24.9275 30.0136 24.3921C26.2646 21.8849 22.189 17.8106 20.0206 16.1653C19.3022 15.6299 18.8058 15.3426 18.5968 15.4732C18.5445 15.4993 18.5053 15.5515 18.4923 15.6298C18.3878 15.9694 18.3747 16.335 18.4139 16.7007Z",
    fill: "url(#paint129_radial_578_447510)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4668 17.066C18.6366 17.8496 19.0546 18.6331 19.6554 19.4166C19.6685 19.4296 19.6685 19.4297 19.6816 19.4427C20.0082 19.8606 20.387 20.2785 20.805 20.6833C25.2463 25.0057 34.2726 28.6881 34.2726 28.6881C34.2726 28.6881 38.0347 28.44 32.3524 25.75C31.5948 25.3974 30.811 24.9273 30.0142 24.3919C27.5323 23.2558 22.9473 20.9183 18.4668 17.066Z",
    fill: "url(#paint130_radial_578_447510)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3204 19.8737C17.9316 26.4552 33.3586 28.8972 33.3586 28.8972C33.3586 28.8972 34.4428 28.2051 34.6257 27.3432C34.7563 26.6903 34.3906 25.946 32.614 25.3322C24.5674 22.5377 19.6036 19.6126 16.56 17.5493C16.5078 17.5232 16.4686 17.484 16.4294 17.4579C15.7632 17.0008 15.1884 16.583 14.7051 16.2304C12.811 14.8593 12.184 14.35 12.0926 15.3685C12.0926 15.3946 12.0925 15.4208 12.0795 15.4469C11.9097 17.0923 12.393 18.5548 13.3204 19.8737Z",
    fill: "url(#paint131_radial_578_447510)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3453 28.8977C33.3453 28.8977 34.4294 28.2056 34.6123 27.3437C31.3466 26.8736 19.2506 24.9671 14.8224 20.488C12.9675 18.6076 12.236 16.8838 12.0531 15.4604C11.204 25.3849 33.3453 28.8977 33.3453 28.8977Z",
    fill: "url(#paint132_radial_578_447510)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3198 19.8734C14.3649 21.3621 15.9585 22.6288 17.8004 23.7127C24.1096 27.4344 33.358 28.8838 33.358 28.8838C33.358 28.8838 34.4422 28.1917 34.6251 27.3299C34.6643 27.1471 34.6643 26.9643 34.612 26.7815C34.4553 26.2852 33.9067 25.7629 32.6265 25.3189C24.5799 22.5244 19.6161 19.5992 16.5725 17.536C16.5202 17.5099 16.4811 17.4707 16.4419 17.4446C15.7757 16.9876 15.2009 16.5696 14.7176 16.2171C12.8235 14.8459 12.1965 14.3367 12.105 15.3552C12.105 15.3814 12.105 15.4074 12.092 15.4335C11.9091 17.092 12.3924 18.5545 13.3198 19.8734Z",
    fill: "url(#paint133_radial_578_447510)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8011 23.7131C24.1103 27.4347 33.3587 28.8842 33.3587 28.8842C33.3587 28.8842 34.4429 28.1921 34.6258 27.3302C34.665 27.1474 34.6649 26.9646 34.6127 26.7818C33.5154 26.5468 20.6095 23.8436 16.9389 21.6628C16.9259 21.6628 16.8867 22.5508 17.8011 23.7131Z",
    fill: "url(#paint134_radial_578_447510)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5107 17.223C12.5107 17.223 14.1958 20.6835 18.3889 22.9557C18.3889 22.9557 14.2089 21.2189 12.5107 17.223Z",
    fill: "url(#paint135_radial_578_447510)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3197 19.8734C12.2355 17.6926 12.2355 16.7654 12.2355 16.7654C12.7058 18.2411 13.6202 19.1421 13.6202 19.1421C12.6013 17.5751 11.8567 15.4204 12.7058 15.2376C13.0977 15.1592 13.8292 15.6946 14.6652 16.23C12.7711 14.8589 12.1441 14.3496 12.0527 15.3682C12.0527 15.3943 12.0527 15.4204 12.0396 15.4465C11.909 17.0919 12.3923 18.5544 13.3197 19.8734Z",
    fill: "url(#paint136_radial_578_447510)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2698 25.8412C24.0188 29.576 36.2977 31.0777 36.2977 31.0777C37.3428 31.1691 38.2702 30.8426 38.649 30.2942C39.3022 29.367 38.3747 27.8522 33.7374 26.9903C30.4848 26.3896 27.2061 25.4495 24.6066 24.7312C24.6066 24.7312 24.6066 24.7312 24.5936 24.7312C21.341 23.8171 19.1072 23.2295 19.2379 24.013C19.3424 24.6659 19.7081 25.2797 20.2698 25.8412Z",
    fill: "url(#paint137_radial_578_447510)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2972 31.0649C37.3422 31.1563 38.2696 30.8299 38.6485 30.2814C21.1053 29.2498 19.2373 24.0002 19.2373 24.0002C20.0341 29.0931 36.2972 31.0649 36.2972 31.0649Z",
    fill: "url(#paint138_radial_578_447510)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1201 30.1246C37.1201 30.1246 25.5596 30.1116 20.9746 25.5933C20.9746 25.5802 23.757 29.0799 37.1201 30.1246Z",
    fill: "url(#paint139_radial_578_447510)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2978 31.0652C37.3428 31.1566 38.2703 30.8301 38.6491 30.2817C39.3022 29.3545 38.3747 27.8397 33.7375 26.9779C26.3963 25.6328 19.0289 22.5902 19.251 23.9874C20.0348 29.0933 36.2978 31.0652 36.2978 31.0652Z",
    fill: "url(#paint140_radial_578_447510)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2698 25.8415C19.8779 25.2538 19.6167 24.7837 19.6167 24.7837C20.3743 25.5672 22.4513 26.7425 22.8432 26.9645C20.8968 25.8415 18.8199 24.0133 19.8388 23.8827C20.4919 23.8043 22.8954 24.3267 24.5936 24.7184C21.341 23.8043 19.1072 23.2167 19.2379 24.0002C19.3424 24.6662 19.7081 25.2799 20.2698 25.8415Z",
    fill: "url(#paint141_radial_578_447510)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3754 15.6558L45.088 16.2565L42.162 22.2242L32.0645 17.2881C28.42 15.4991 25.6246 12.352 24.3053 8.49973L23.3125 5.60071L23.5999 5L45.3754 15.6558Z",
    fill: "url(#paint142_radial_578_447510)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3761 15.6559L23.6006 5.02625L24.5934 7.9252C25.9127 11.7644 28.7081 14.9246 32.3526 16.7136L42.45 21.6497L45.3761 15.6559Z",
    fill: "url(#paint143_radial_578_447510)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3761 15.6559L23.6006 5.02625L24.5934 7.9252C25.9127 11.7644 28.7081 14.9246 32.3526 16.7136L42.45 21.6497L45.3761 15.6559Z",
    fill: "url(#paint144_radial_578_447510)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6002 5.01331L45.3757 15.656L45.2973 15.8127L23.9006 5.36591L24.8934 8.26487C25.5596 10.2106 26.6046 11.9866 27.9501 13.4883C26.4609 11.9213 25.2984 10.0278 24.593 7.92533L23.6394 5.20918L23.2998 5.64009L23.6002 5.01331Z",
    fill: "url(#paint145_radial_578_447510)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8429 16.374L42.4759 21.5713L42.4498 21.6235L32.3523 16.6874C31.7776 16.4131 31.2289 16.0867 30.6934 15.7472C31.0722 15.9692 31.451 16.1781 31.8429 16.374Z",
    fill: "url(#paint146_radial_578_447510)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6469 16.3478C31.6469 16.3478 28.4465 14.8069 26.252 11.3073C26.252 11.3073 27.7934 13.932 31.6469 16.3478Z",
    fill: "url(#paint147_radial_578_447510)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4105 17.2231C32.2088 13.7626 29.6746 9.70132 27.9111 7.14185L33.8808 10.067C34.9389 13.3447 37.6559 17.5495 39.5238 20.2265L33.4105 17.2231Z",
    fill: "url(#paint148_radial_578_447510)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1924 8.48669L28.6554 10.9939C29.9094 13.1224 31.712 14.8201 33.8935 15.8778L43.0113 20.3308L44.6311 17.0139L27.1924 8.48669Z",
    fill: "url(#paint149_radial_578_447510)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1143 8.38232L28.6687 10.7721C29.988 12.8092 31.8429 14.4546 34.0375 15.5254L43.2336 20.0175L44.7228 16.9749L27.1143 8.38232Z",
    fill: "url(#paint150_radial_578_447510)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3096 8.72192L28.8249 11.1117C30.105 13.1357 31.9337 14.755 34.0891 15.8127L43.1416 20.2265L44.6307 17.1839L27.3096 8.72192Z",
    fill: "url(#paint151_radial_578_447510)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8349 17.0136L28.0029 9.2699L28.1466 9.47885C29.1655 11.0589 30.6024 12.3256 32.3005 13.1613L43.1687 18.4631L43.8349 17.0136Z",
    fill: "url(#paint152_radial_578_447510)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7275 9.75315C27.7275 9.75315 28.9423 11.8556 29.922 12.9395C29.922 12.9395 28.4068 11.8164 27.4401 12.4563C27.4401 12.4563 25.4938 9.64868 24.9844 8.05554C24.9844 8.0686 26.1339 9.38751 27.7275 9.75315Z",
    fill: "url(#paint153_radial_578_447510)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9205 16.7789L42.803 17.3404L41.6012 22.9425L32.1438 20.9184C28.7214 20.1871 25.7431 18.1239 23.8359 15.1857L22.4121 12.9789L22.5297 12.4174L42.9205 16.7789Z",
    fill: "url(#paint154_radial_578_447510)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9202 16.7793L22.5293 12.3916L23.9532 14.5985C25.8603 17.5367 28.8386 19.5999 32.261 20.3312L41.7184 22.3552L42.9202 16.7793Z",
    fill: "url(#paint155_radial_578_447510)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9202 16.7793L22.5293 12.3916L23.9532 14.5985C25.8603 17.5367 28.8386 19.5999 32.261 20.3312L41.7184 22.3552L42.9202 16.7793Z",
    fill: "url(#paint156_radial_578_447510)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M22.53 12.4174L42.9209 16.805L42.8948 16.9486L22.8566 12.6393L24.2805 14.8462C25.2341 16.3349 26.4881 17.5885 27.9119 18.5679C26.3444 17.5624 24.9859 16.2174 23.9539 14.6242L22.5954 12.5479L22.3994 12.9789L22.53 12.4174Z",
    fill: "url(#paint157_radial_578_447510)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7648 20.1873L41.7316 22.3289L41.7186 22.3811L32.2612 20.3571C31.7256 20.2395 31.1901 20.0959 30.6807 19.9131C31.0464 20.0045 31.3991 20.109 31.7648 20.1873Z",
    fill: "url(#paint158_radial_578_447510)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5956 20.2002C31.5956 20.2002 28.6173 19.5865 26.0439 17.1053C26.0439 17.1184 27.8858 18.9727 31.5956 20.2002Z",
    fill: "url(#paint159_radial_578_447510)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2541 20.5525C31.5429 17.9016 28.5777 15.0418 26.5791 13.2659L32.183 14.4672C33.7506 16.9875 36.8856 19.9387 39.0148 21.78L33.2541 20.5525Z",
    fill: "url(#paint160_radial_578_447510)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2402 14.5592L27.9906 16.3482C29.4798 17.876 31.3346 18.9077 33.3724 19.3386L41.9024 21.1668L42.5686 18.0589L26.2402 14.5592Z",
    fill: "url(#paint161_radial_578_447510)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1621 14.4943L27.9517 16.1788C29.48 17.6022 31.3741 18.5946 33.4119 19.0386L42.0333 20.8929L42.6472 18.0461L26.1621 14.4943Z",
    fill: "url(#paint162_radial_578_447510)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3975 14.7422L28.1609 16.4137C29.6631 17.837 31.505 18.8165 33.5297 19.2474L42.0074 21.0756L42.6213 18.2288L26.3975 14.7422Z",
    fill: "url(#paint163_radial_578_447510)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M41.915 18.2418L27.0889 15.0555L27.2587 15.2123C28.4474 16.3222 29.9104 17.0796 31.491 17.4192L41.6668 19.6L41.915 18.2418Z",
    fill: "url(#paint164_radial_578_447510)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9708 15.5251C26.9708 15.5251 28.4207 17.0268 29.4657 17.732C29.4657 17.732 27.9635 17.1052 27.2973 17.8495C27.2973 17.8495 25.0898 15.9038 24.3321 14.6894C24.3191 14.6763 25.5469 15.5251 26.9708 15.5251Z",
    fill: "url(#paint165_radial_578_447510)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M44.841 19.4171L44.8279 19.9917L44.7757 25.7113L35.0962 25.6199C31.5954 25.5938 28.2644 24.1704 25.8086 21.6762L23.9668 19.7958L23.9799 19.2212L44.841 19.4171Z",
    fill: "url(#paint166_radial_578_447510)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8412 19.4166L23.9932 19.2338L25.835 21.1142C28.2908 23.6084 31.6218 25.0187 35.1226 25.0579L44.802 25.1493L44.8412 19.4166Z",
    fill: "url(#paint167_radial_578_447510)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8412 19.4166L23.9932 19.2338L25.835 21.1142C28.2908 23.6084 31.6218 25.0187 35.1226 25.0579L44.802 25.1493L44.8412 19.4166Z",
    fill: "url(#paint168_radial_578_447510)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9805 19.2338L44.8285 19.4166V19.5602L24.3463 19.3774L26.188 21.2578C27.429 22.5245 28.892 23.5039 30.4987 24.1699C28.7614 23.5039 27.1547 22.4593 25.8223 21.1012L24.0719 19.3383L23.9805 19.7953V19.2338Z",
    fill: "url(#paint169_radial_578_447510)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6003 24.9926L44.7892 25.084V25.1363L35.1098 25.0448C34.5611 25.0317 34.0125 24.9926 33.4639 24.9272C33.8427 24.9664 34.2215 24.9926 34.6003 24.9926Z",
    fill: "url(#paint170_radial_578_447510)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4429 25.0451C34.4429 25.0451 31.3863 25.032 28.3818 23.1385C28.3818 23.1385 30.5502 24.5881 34.4429 25.0451Z",
    fill: "url(#paint171_radial_578_447510)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1158 25.071C33.9082 22.8249 30.4205 20.618 28.1084 19.286L33.8298 19.3383C35.8807 21.493 39.5382 23.7521 41.994 25.1232L36.1158 25.071Z",
    fill: "url(#paint172_radial_578_447510)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M28.042 20.5919L30.1189 21.9892C31.8824 23.1906 33.9071 23.8174 35.9841 23.8435L44.7231 23.9218L44.7491 20.7356L28.042 20.5919Z",
    fill: "url(#paint173_radial_578_447510)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9639 20.5524L30.0539 21.8321C31.8304 22.929 33.8813 23.5166 35.9843 23.5297L44.8017 23.6081L44.8278 20.696L27.9639 20.5524Z",
    fill: "url(#paint174_radial_578_447510)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2383 20.7358L30.2891 22.0156C32.0395 23.1125 34.0511 23.7002 36.1151 23.7132L44.7887 23.7915L44.8148 20.8795L28.2383 20.7358Z",
    fill: "url(#paint175_radial_578_447510)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1481 21.0493L28.9824 20.9187L29.1784 21.0363C30.563 21.8851 32.1566 22.3421 33.7633 22.3551L44.1743 22.4466L44.1481 21.0493Z",
    fill: "url(#paint176_radial_578_447510)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9437 21.3881C28.9437 21.3881 30.668 22.5764 31.8306 23.0465C31.8306 23.0465 30.2369 22.7331 29.7275 23.5949C29.7275 23.5949 27.1803 22.1324 26.1875 21.1008C26.1875 21.0877 27.5722 21.6753 28.9437 21.3881Z",
    fill: "url(#paint177_radial_578_447510)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6455 16.7525V31.4173C33.6455 32.0963 33.9982 32.7492 34.586 33.1018L46.029 40.284C46.6821 40.6888 47.505 40.6888 48.1582 40.284L59.6011 33.1018C60.1758 32.7362 60.5416 32.0963 60.5416 31.4173V16.7525C60.5416 16.0735 60.1889 15.4205 59.6011 15.068L48.1582 7.88576C47.505 7.48095 46.6821 7.48095 46.029 7.88576L34.586 15.068C33.9982 15.4336 33.6455 16.0735 33.6455 16.7525Z",
    fill: "url(#paint178_radial_578_447510)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9922 15.8648V30.412C32.9922 31.1302 33.371 31.7962 33.985 32.1749L46.0288 39.3832C46.6819 39.775 47.4918 39.775 48.1318 39.3832L60.1756 32.1749C60.7896 31.8093 61.1684 31.1433 61.1684 30.412V15.8648C61.1684 15.1466 60.7896 14.4806 60.1756 14.1019L48.1318 6.89355C47.4787 6.50179 46.6689 6.50179 46.0288 6.89355L33.985 14.1019C33.371 14.4806 32.9922 15.1466 32.9922 15.8648Z",
    fill: "url(#paint179_radial_578_447510)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1821 14.8986V29.498C61.1821 30.0073 60.9078 30.4904 60.4636 30.7386L47.8189 38.0383C47.3748 38.2994 46.8262 38.2994 46.369 38.0383L33.7243 30.7386C33.2802 30.4774 33.0059 30.0073 33.0059 29.498V14.8986C33.0059 14.3893 33.2802 13.9061 33.7243 13.658L46.369 6.35823C46.8131 6.09706 47.3617 6.09706 47.8189 6.35823L60.4636 13.658C60.9078 13.8931 61.1821 14.3762 61.1821 14.8986Z",
    fill: "url(#paint180_radial_578_447510)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4636 13.6318L47.8189 6.33211C47.3748 6.07094 46.8262 6.07094 46.369 6.33211L33.7243 13.6318C33.2802 13.893 33.0059 14.3631 33.0059 14.8855V15.46C33.0059 14.9507 33.2802 14.4676 33.7243 14.2064L46.369 6.90667C46.8131 6.6455 47.3617 6.6455 47.8189 6.90667L60.4636 14.2064C60.9078 14.4676 61.1821 14.9377 61.1821 15.46V14.8855C61.1821 14.3762 60.9078 13.893 60.4636 13.6318Z",
    fill: "url(#paint181_radial_578_447510)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4636 30.647L47.8189 37.9468C47.3748 38.2079 46.8262 38.2079 46.369 37.9468L33.7243 30.647C33.2802 30.3858 33.0059 29.9158 33.0059 29.3934V29.4848C33.0059 29.9941 33.2802 30.4773 33.7243 30.7384L46.369 38.0381C46.8131 38.2993 47.3617 38.2993 47.8189 38.0381L60.4636 30.7384C60.9078 30.4773 61.1821 30.0071 61.1821 29.4848V29.3934C61.1821 29.9158 60.9078 30.3989 60.4636 30.647Z",
    fill: "url(#paint182_radial_578_447510)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1815 16.8833H32.9922V22.9686H61.1815V16.8833Z",
    fill: "url(#paint183_radial_578_447510)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1815 22.9557H32.9922V29.041H61.1815V22.9557Z",
    fill: "url(#paint184_radial_578_447510)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7803 6.6847C46.2244 6.42352 46.7731 6.42352 47.2302 6.6847L59.875 13.9845C60.3191 14.2456 60.5934 14.7157 60.5934 15.225V29.8245C60.5934 30.3076 60.3583 30.7647 59.9403 31.0259L60.4366 30.7385C60.8808 30.4774 61.1551 30.0073 61.1551 29.498V14.8986C61.1551 14.3893 60.8808 13.9061 60.4366 13.658L47.792 6.35823C47.3478 6.09706 46.7992 6.09706 46.342 6.35823",
    fill: "url(#paint185_radial_578_447510)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M60.463 30.6734L47.8183 37.9731C47.3742 38.2343 46.8256 38.2343 46.3684 37.9731L33.7237 30.6734C33.4363 30.5037 33.2143 30.2425 33.0967 29.9421V15.7867C33.0967 15.2513 33.3057 14.7681 33.6453 14.3894C33.2404 14.7812 32.9922 15.3166 32.9922 15.8911V29.4198V29.5112V30.4253C32.9922 31.1435 33.371 31.8095 33.985 32.1882L46.0288 39.3965C46.6819 39.7883 47.4918 39.7883 48.1318 39.3965L60.1756 32.1882C60.3455 32.0968 60.4891 31.9662 60.6198 31.8356C60.5153 31.927 60.3977 32.0184 60.2671 32.0968L48.2233 39.3051C47.5702 39.6969 46.7603 39.6969 46.1202 39.3051L34.0764 32.0968C33.4625 31.7312 33.0837 31.0652 33.0837 30.3339V30.0205C33.2012 30.3339 33.4233 30.5951 33.7106 30.7518L46.3554 38.0515C46.7995 38.3127 47.3481 38.3127 47.8053 38.0515L60.45 30.7518C60.8941 30.4906 61.1684 30.0205 61.1684 29.4982V29.4067C61.1815 29.9421 60.9072 30.4123 60.463 30.6734Z",
    fill: "url(#paint186_radial_578_447510)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8926 17.1052V28.7795C35.8926 29.1713 36.1015 29.5369 36.4412 29.7197L46.5517 35.5569C46.8914 35.7528 47.3094 35.7528 47.649 35.5569L57.7595 29.7197C58.0991 29.5239 58.3082 29.1582 58.3082 28.7795V17.1052C58.3082 16.7134 58.0991 16.3478 57.7595 16.1649L47.649 10.3278C47.3094 10.1319 46.8914 10.1319 46.5517 10.3278L36.4412 16.1649C36.1015 16.3478 35.8926 16.7134 35.8926 17.1052Z",
    fill: "url(#paint187_linear_578_447510)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4805 17.4055V28.4661C36.4805 28.8318 36.6764 29.1843 37.003 29.3671L46.5779 34.8909C46.8914 35.0737 47.2963 35.0737 47.6098 34.8909L57.1848 29.3671C57.4983 29.1843 57.7073 28.8318 57.7073 28.4661V17.4055C57.7073 17.0399 57.5114 16.6873 57.1848 16.5045L47.6098 10.9807C47.2963 10.7979 46.8914 10.7979 46.5779 10.9807L37.003 16.5045C36.6633 16.7004 36.4805 17.0399 36.4805 17.4055Z",
    fill: "url(#paint188_radial_578_447510)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4805 17.4055V28.4661C36.4805 28.8318 36.6764 29.1843 37.003 29.3671L46.5779 34.8909C46.8914 35.0737 47.2963 35.0737 47.6098 34.8909L57.1848 29.3671C57.4983 29.1843 57.7073 28.8318 57.7073 28.4661V17.4055C57.7073 17.0399 57.5114 16.6873 57.1848 16.5045L47.6098 10.9807C47.2963 10.7979 46.8914 10.7979 46.5779 10.9807L37.003 16.5045C36.6633 16.7004 36.4805 17.0399 36.4805 17.4055Z",
    fill: "url(#paint189_radial_578_447510)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8789 17.236C35.8789 16.8443 36.0879 16.4786 36.4276 16.2958L46.5381 10.4587C46.8777 10.2628 47.2957 10.2628 47.6353 10.4587L57.7458 16.2958C58.0855 16.4917 58.2945 16.8573 58.2945 17.236V17.0924C58.2945 16.7006 58.0855 16.3349 57.7458 16.1521L47.6353 10.315C47.2957 10.1191 46.8777 10.1191 46.5381 10.315L36.4276 16.1521C36.0879 16.348 35.8789 16.7137 35.8789 17.0924V28.7667V17.236Z",
    fill: "url(#paint190_radial_578_447510)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7458 29.5369L47.6353 35.374C47.2957 35.5699 46.8777 35.5699 46.5381 35.374L36.4276 29.5369C36.0879 29.341 35.8789 28.9754 35.8789 28.5967V28.7664C35.8789 29.1582 36.0879 29.5238 36.4276 29.7067L46.5381 35.5438C46.8777 35.7397 47.2957 35.7397 47.6353 35.5438L57.7458 29.7067C58.0855 29.5108 58.2945 29.1451 58.2945 28.7664V28.5967C58.2945 28.9884 58.0855 29.354 57.7458 29.5369Z",
    fill: "url(#paint191_radial_578_447510)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1975 16.5178L47.6225 10.994C47.309 10.8112 46.9041 10.8112 46.5906 10.994L37.0157 16.5178C36.7022 16.7007 36.4932 17.0532 36.4932 17.4189V28.4795C36.4932 28.8451 36.6891 29.1977 37.0157 29.3805L46.5906 34.9042C46.9041 35.0871 47.309 35.0871 47.6225 34.9042L57.1975 29.3805C57.511 29.1977 57.72 28.8451 57.72 28.4795V17.4189C57.707 17.0402 57.511 16.7007 57.1975 16.5178ZM57.2105 28.2052C57.2105 28.5578 57.0277 28.8843 56.7142 29.0671L47.5834 34.3428C47.2699 34.5125 46.9041 34.5125 46.6037 34.3428L37.4729 29.0671C37.1594 28.8974 36.9764 28.5709 36.9764 28.2052V17.667C36.9764 17.3144 37.1594 16.9879 37.4729 16.8051L46.6037 11.5295C46.9172 11.3597 47.2829 11.3597 47.5834 11.5295L56.7142 16.8051C57.0277 16.9749 57.2105 17.3013 57.2105 17.667V28.2052Z",
    fill: "url(#paint192_linear_578_447510)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0226 28.8447V17.1704C36.0226 16.7786 36.2316 16.413 36.5712 16.2302L46.6818 10.393C47.0214 10.1971 47.4394 10.1971 47.779 10.393L57.8895 16.2302C57.9157 16.2432 57.9549 16.2693 57.981 16.2824C57.9157 16.2171 57.8373 16.1518 57.7458 16.1126L47.6353 10.2754C47.2957 10.0796 46.8777 10.0796 46.5381 10.2754L36.4276 16.1126C36.0879 16.3085 35.8789 16.6742 35.8789 17.0529V28.7272C35.8789 29.0798 36.0487 29.4062 36.3361 29.6152C36.1402 29.4193 36.0226 29.1451 36.0226 28.8447Z",
    fill: "url(#paint193_radial_578_447510)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9951 18.3846V27.6692C37.9951 27.9826 38.1649 28.2699 38.4262 28.4266L46.4728 33.0624C46.7471 33.2191 47.0736 33.2191 47.3479 33.0624L55.3946 28.4266C55.6689 28.2699 55.8257 27.9826 55.8257 27.6692V18.3846C55.8257 18.0712 55.6558 17.7839 55.3946 17.6272L47.3479 12.9914C47.0736 12.8347 46.7471 12.8347 46.4728 12.9914L38.4262 17.6272C38.178 17.7839 37.9951 18.0712 37.9951 18.3846Z",
    fill: "url(#paint194_radial_578_447510)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3086 18.2283V27.5128C38.3086 27.8262 38.4784 28.1136 38.7396 28.2703L46.7863 32.9061C47.0606 33.0628 47.3872 33.0628 47.6615 32.9061L55.708 28.2703C55.9824 28.1136 56.1392 27.8262 56.1392 27.5128V18.2283C56.1392 17.9149 55.9693 17.6275 55.708 17.4708L47.6615 12.8351C47.3872 12.6784 47.0606 12.6784 46.7863 12.8351L38.7396 17.4708C38.4784 17.6275 38.3086 17.9149 38.3086 18.2283Z",
    fill: "url(#paint195_radial_578_447510)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1787 18.2673V27.5519C38.1787 27.8653 38.3485 28.1526 38.6098 28.3093L46.6564 32.9451C46.9307 33.1018 47.2573 33.1018 47.5316 32.9451L55.5782 28.3093C55.8525 28.1526 56.0093 27.8653 56.0093 27.5519V18.2673C56.0093 17.9539 55.8394 17.6666 55.5782 17.5099L47.5316 12.8741C47.2573 12.7174 46.9307 12.7174 46.6564 12.8741L38.6098 17.5099C38.3354 17.6666 38.1787 17.9669 38.1787 18.2673Z",
    fill: "url(#paint196_linear_578_447510)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5386 18.5155V27.3169C55.5386 27.6042 55.3818 27.8915 55.1206 28.0351L47.492 32.4359C47.4397 32.462 47.3875 32.4881 47.3222 32.5012C47.3091 32.5142 47.283 32.5142 47.27 32.5142C47.061 32.5665 46.8389 32.5273 46.656 32.4228L42.3062 29.9156L39.0274 28.0221C38.7662 27.8785 38.6094 27.5912 38.6094 27.3039V18.5024C38.6094 18.3065 38.6747 18.1237 38.7922 17.9801C38.8445 17.9017 38.9229 17.8495 39.0143 17.7842L46.6298 13.3835C46.878 13.2398 47.2046 13.2398 47.4528 13.3835L51.5153 15.734L55.0814 17.7842C55.2121 17.8625 55.3165 17.9801 55.3949 18.0976C55.4994 18.2413 55.5386 18.3718 55.5386 18.5155Z",
    fill: "url(#paint197_radial_578_447510)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4657 27.656L47.3351 32.4877C47.1131 32.553 46.8779 32.5399 46.682 32.4224L39.0664 28.0217C38.8052 27.878 38.6484 27.5907 38.6484 27.3035V18.502C38.6484 18.3061 38.7137 18.1233 38.8313 17.9796L47.4657 27.656Z",
    fill: "url(#paint198_radial_578_447510)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4346 18.1234C54.0499 18.8808 52.6391 21.9496 52.6391 21.9496L47.623 21.2444L51.568 15.7468L55.1341 17.797C55.2517 17.8753 55.3562 17.9929 55.4346 18.1234Z",
    fill: "url(#paint199_radial_578_447510)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3355 29.8237L47.2832 32.5138C47.0742 32.5661 46.8521 32.5269 46.6692 32.4224L42.3193 29.9152L43.3252 28.2437L47.3355 29.8237Z",
    fill: "url(#paint200_radial_578_447510)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M54.86 18.868V26.9643C54.86 27.2385 54.7163 27.4866 54.4812 27.6172L47.4666 31.6653C47.2315 31.7959 46.944 31.7959 46.7089 31.6653L39.6943 27.6172C39.642 27.5911 39.5898 27.5519 39.5375 27.4997C39.3938 27.356 39.3154 27.1602 39.3154 26.9643V18.868C39.3154 18.5938 39.4592 18.3456 39.6943 18.2151L46.7089 14.1669C46.944 14.0363 47.2315 14.0363 47.4666 14.1669L54.4812 18.2151C54.6772 18.3326 54.8078 18.5285 54.847 18.7374C54.8601 18.7766 54.86 18.8157 54.86 18.868Z",
    fill: "url(#paint201_radial_578_447510)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8395 31.5999L39.8249 27.5518C39.5898 27.4212 39.4461 27.16 39.4461 26.8989V18.8026C39.4461 18.5283 39.5898 18.2802 39.8249 18.1496L46.8004 14.1276C46.7743 14.1406 46.735 14.1537 46.7089 14.1798L39.6943 18.228C39.4592 18.3586 39.3154 18.6198 39.3154 18.8809V26.9772C39.3154 27.2514 39.4592 27.4996 39.6943 27.6301L46.7089 31.6783C46.944 31.8089 47.2315 31.8089 47.4666 31.6783L47.5058 31.6652C47.2837 31.7305 47.0486 31.7175 46.8395 31.5999Z",
    fill: "url(#paint202_radial_578_447510)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4802 18.2153L47.4656 14.1672C47.3088 14.0758 47.1259 14.0496 46.9561 14.0758C47.0083 14.0888 47.0867 14.1149 47.139 14.1541L54.3365 18.3067C54.5716 18.4373 54.7284 18.6985 54.7284 18.9858V27.291C54.7284 27.3433 54.7153 27.4085 54.7153 27.4608C54.8198 27.3302 54.8851 27.1604 54.8851 26.9906V18.8943C54.859 18.594 54.7153 18.3459 54.4802 18.2153Z",
    fill: "url(#paint203_radial_578_447510)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M54.847 18.7373C46.5391 20.8527 41.1312 25.8802 39.5375 27.5126C39.3938 27.3689 39.3154 27.1731 39.3154 26.9772V18.8809C39.3154 18.6067 39.4592 18.3586 39.6943 18.228L46.7089 14.1798C46.944 14.0493 47.2315 14.0493 47.4666 14.1798L54.4812 18.228C54.6772 18.3194 54.8078 18.5153 54.847 18.7373Z",
    fill: "url(#paint204_radial_578_447510)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1546 36.8312C58.1149 36.8894 58.115 36.9659 58.1547 37.0241C58.3567 37.3196 58.581 37.6032 58.8226 37.8696C58.8367 37.8836 58.8507 37.9047 58.8719 37.9188C58.9494 38.0031 59.0339 38.0875 59.1184 38.1718C59.3156 38.3686 59.5129 38.5514 59.7312 38.7201C59.906 38.8644 60.086 38.9985 60.2755 39.1266C60.3339 39.1661 60.4104 39.1659 60.4678 39.1251C60.8079 38.883 61.3008 38.46 61.7184 38.037C62.0675 37.6833 62.4236 37.221 62.5736 37.0206C62.6184 36.9608 62.6191 36.8797 62.576 36.8187C62.4904 36.6973 62.3467 36.4964 62.253 36.3794C62.0558 36.1334 61.8444 35.8945 61.6261 35.6695C61.5063 35.55 61.3866 35.4376 61.2598 35.3251C61.0077 35.105 60.7444 34.9018 60.4698 34.7105C60.4111 34.6695 60.3332 34.6691 60.274 34.7094C60.0762 34.844 59.8845 34.9845 59.7031 35.1353C59.4988 35.304 59.3086 35.4797 59.1255 35.6625C58.7594 36.0343 58.4357 36.4183 58.1546 36.8312Z",
    fill: "#1C7663"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6741 36.9252C58.8367 37.1714 59.0203 37.4071 59.2197 37.6271C59.2302 37.6375 59.2407 37.6532 59.2564 37.6637C59.3141 37.7266 59.3771 37.7894 59.44 37.8523C59.5869 37.9989 59.7338 38.1351 59.8964 38.2608C60.0486 38.3865 60.206 38.5018 60.3738 38.6118C60.6257 38.4442 60.8617 38.2608 61.0873 38.0618C61.4493 37.737 61.7693 37.3704 62.0421 36.9619C62.0526 36.9461 62.0631 36.9357 62.0684 36.9199C61.9739 36.7838 61.8795 36.6476 61.7746 36.5166C61.6277 36.3333 61.4703 36.1552 61.3077 35.9876C61.2185 35.8986 61.1293 35.8148 61.0349 35.731C60.825 35.5476 60.6047 35.38 60.3738 35.2229C60.2007 35.3381 60.0328 35.4586 59.8754 35.5895C59.7233 35.7153 59.5817 35.8462 59.4453 35.9824C59.1515 36.2809 58.8944 36.59 58.6741 36.9252Z",
    fill: "url(#paint205_radial_578_447510)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6736 36.9255H60.3682V35.2389C60.0324 35.4589 59.7176 35.7155 59.4343 35.9984C59.151 36.2812 58.894 36.5902 58.6736 36.9255Z",
    fill: "url(#paint206_radial_578_447510)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M60.369 35.2389V36.9307H62.0635C61.8431 36.5955 61.5861 36.2812 61.3028 35.9984C61.0142 35.7155 60.7047 35.4589 60.369 35.2389Z",
    fill: "url(#paint207_radial_578_447510)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M60.369 36.9255V38.6173C61.0405 38.1721 61.6175 37.596 62.0635 36.9255H60.369Z",
    fill: "url(#paint208_radial_578_447510)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6736 36.9255C58.894 37.2608 59.151 37.575 59.4343 37.8579C59.7176 38.1407 60.0324 38.3974 60.3682 38.6173V36.9255H58.6736Z",
    fill: "url(#paint209_radial_578_447510)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6744 36.9252C58.8948 37.2604 59.1518 37.5746 59.4351 37.8575C59.7184 38.1403 60.0332 38.397 60.369 38.617C60.6208 38.4494 60.71 38.3917 60.9355 38.1927L59.8706 35.6052C59.7184 35.7309 59.5768 35.8619 59.4404 35.9981C59.1518 36.2809 58.8948 36.5899 58.6744 36.9252Z",
    fill: "url(#paint210_radial_578_447510)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2514 37.6687C59.3091 37.7315 59.372 37.7944 59.435 37.8572C59.7183 38.1401 60.0331 38.3967 60.3688 38.6167C60.6206 38.4491 60.8567 38.2658 61.0823 38.0667C61.4443 37.742 61.7643 37.3753 62.0371 36.9668C61.3289 37.1763 60.2901 37.4644 59.2514 37.6687Z",
    fill: "url(#paint211_radial_578_447510)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2196 37.6272C59.2301 37.6377 59.2406 37.6534 59.2563 37.6639C59.314 37.7267 59.377 37.7896 59.4399 37.8524C59.5868 37.9991 59.7337 38.1353 59.8963 38.261C60.2951 37.5539 60.7357 36.7053 60.7725 36.3754C60.7672 36.3806 59.8859 37.1087 59.2196 37.6272Z",
    fill: "url(#paint212_radial_578_447510)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3688 36.9254L61.7695 36.5221C61.6226 36.3388 61.4652 36.1607 61.3026 35.9931C61.2134 35.9041 61.1242 35.8203 61.0298 35.7365L60.3688 36.9254Z",
    fill: "url(#paint213_radial_578_447510)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3679 38.0414C60.8086 37.748 61.1916 37.3709 61.4854 36.9257C61.1916 36.4857 60.8138 36.1034 60.3679 35.8101C59.9272 36.1034 59.5443 36.4805 59.2505 36.9257C59.5443 37.3709 59.922 37.748 60.3679 38.0414Z",
    fill: "url(#paint214_radial_578_447510)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7687 36.6004C61.6218 36.4171 61.4644 36.239 61.3018 36.0714C61.2126 35.9824 61.1234 35.8986 61.029 35.8148C60.8191 35.6314 60.5988 35.4638 60.368 35.3067C60.1949 35.4219 60.027 35.5424 59.8696 35.6734C59.7174 35.7991 59.5758 35.93 59.4394 36.0662C59.1666 36.3386 58.92 36.6371 58.7049 36.9566C58.6944 36.9409 58.6892 36.9304 58.6787 36.9147C58.899 36.5795 59.1561 36.2652 59.4394 35.9824C59.5758 35.8462 59.7227 35.7153 59.8696 35.5895C60.027 35.4586 60.1949 35.3329 60.368 35.2229C60.5988 35.3748 60.8191 35.5476 61.029 35.731C61.1234 35.8148 61.2126 35.8986 61.3018 35.9876C61.4697 36.1552 61.6271 36.3281 61.7687 36.5166C61.8736 36.6476 61.9681 36.7838 62.0625 36.9199C62.052 36.9357 62.0468 36.9461 62.0363 36.9619C61.9471 36.8414 61.8579 36.7209 61.7687 36.6004Z",
    fill: "url(#paint215_radial_578_447510)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2197 37.5486C59.2302 37.5591 59.2407 37.5748 59.2564 37.5853C59.3141 37.6481 59.3771 37.711 59.44 37.7739C59.5869 37.9205 59.7338 38.0567 59.8964 38.1824C60.0486 38.3081 60.206 38.4233 60.3738 38.5333C60.6257 38.3657 60.8617 38.1824 61.0873 37.9834C61.4493 37.6586 61.7693 37.292 62.0421 36.8834C62.0526 36.8991 62.0631 36.9096 62.0684 36.9253C62.0579 36.941 62.0474 36.9515 62.0421 36.9672C61.7693 37.3705 61.4493 37.7372 61.0873 38.0672C60.867 38.2662 60.6257 38.4548 60.3738 38.6171C60.2112 38.5071 60.0486 38.3919 59.8964 38.2662C59.739 38.1353 59.5869 37.9991 59.44 37.8577C59.3771 37.7948 59.3193 37.7319 59.2564 37.6691C59.2459 37.6586 59.2354 37.6429 59.2197 37.6324C59.0203 37.4124 58.8419 37.1767 58.6741 36.9306C58.6846 36.9148 58.695 36.9044 58.7003 36.8887C58.8577 37.1191 59.0308 37.3391 59.2197 37.5486Z",
    fill: "url(#paint216_radial_578_447510)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3022 36.0714C61.4648 36.239 61.6222 36.4171 61.7691 36.6004L62.0119 36.9283C61.7457 37.3189 61.436 37.6706 61.0873 37.9834C60.8617 38.1824 60.6257 38.3658 60.3738 38.5334C60.206 38.4234 60.0486 38.3082 59.8964 38.1824C59.7338 38.0567 59.5869 37.9206 59.44 37.7739C59.3771 37.711 59.3141 37.6482 59.2564 37.5853C59.2456 37.5782 59.2373 37.5686 59.2298 37.5599C59.2263 37.5558 59.223 37.552 59.2197 37.5487C59.041 37.3505 58.8765 37.143 58.726 36.9261C58.9362 36.6181 59.1757 36.3299 59.4398 36.0662C59.5762 35.93 59.7179 35.7991 59.87 35.6734C60.0274 35.5424 60.1953 35.4219 60.3684 35.3067C60.5992 35.4638 60.8196 35.6314 61.0294 35.8148C61.1238 35.8986 61.213 35.9824 61.3022 36.0714ZM58.6821 36.9193C58.6812 36.9178 58.6802 36.9163 58.6791 36.9147C58.8994 36.5795 59.1565 36.2652 59.4398 35.9824C59.5762 35.8462 59.7231 35.7153 59.87 35.5895C60.0274 35.4586 60.1953 35.3329 60.3684 35.2229C60.5992 35.3748 60.8196 35.5476 61.0294 35.731C61.1238 35.8148 61.213 35.8986 61.3022 35.9876C61.4701 36.1552 61.6275 36.3281 61.7691 36.5166C61.8655 36.637 61.9531 36.7617 62.0399 36.8868C62.0406 36.8857 62.0414 36.8846 62.0421 36.8835C62.0453 36.8882 62.0484 36.8924 62.0514 36.8964C62.0584 36.9059 62.0647 36.9143 62.0684 36.9254C62.0652 36.9301 62.0621 36.9343 62.0591 36.9383C62.0521 36.9478 62.0458 36.9562 62.0421 36.9673C61.7693 37.3706 61.4493 37.7372 61.0873 38.0672C60.867 38.2662 60.6257 38.4548 60.3738 38.6172C60.2112 38.5072 60.0486 38.392 59.8964 38.2662C59.739 38.1353 59.5869 37.9991 59.44 37.8577C59.4085 37.8263 59.3784 37.7948 59.3482 37.7634C59.318 37.732 59.2879 37.7006 59.2564 37.6691C59.2531 37.6658 59.2497 37.662 59.2463 37.6579C59.2387 37.6492 59.2304 37.6396 59.2197 37.6325C59.0203 37.4125 58.8419 37.1768 58.6741 36.9306C58.6768 36.9265 58.6795 36.9228 58.6821 36.9193Z",
    fill: "url(#paint217_radial_578_447510)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3682 35.8143C60.3682 35.8143 59.7071 36.2281 59.2507 36.93C59.2507 36.9247 59.576 36.2019 60.3682 35.8143Z",
    fill: "url(#paint218_radial_578_447510)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4805 36.9258C61.4805 36.9258 61.087 37.6172 60.4207 38.031L60.3683 38.5338L60.3315 38.0205C60.3315 38.0205 59.8332 37.811 59.2508 36.9258C59.2508 36.9258 59.9853 37.9105 60.3788 37.9629C60.3788 37.9681 60.8352 37.79 61.4805 36.9258Z",
    fill: "url(#paint219_radial_578_447510)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3633 38.0361C60.3633 38.0361 59.6708 37.6433 59.2563 36.9781L58.7527 36.9257L59.2668 36.889C59.2668 36.889 59.4767 36.3915 60.3633 35.8101C60.3633 35.8101 59.377 36.5434 59.3245 36.9362C59.3193 36.9362 59.4977 37.3919 60.3633 38.0361Z",
    fill: "url(#paint220_radial_578_447510)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3894 35.8101C60.3894 35.8101 61.0819 36.2029 61.4964 36.8681L62 36.9205L61.4859 36.9571C61.4859 36.9571 61.276 37.4547 60.3894 38.0361C60.3894 38.0361 61.3757 37.3028 61.4282 36.91C61.4334 36.91 61.255 36.4543 60.3894 35.8101Z",
    fill: "url(#paint221_radial_578_447510)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2508 36.9198C59.2508 36.9198 59.6443 36.2284 60.3106 35.8146L60.363 35.3118L60.3997 35.8251C60.3997 35.8251 60.8981 36.0346 61.4805 36.9198C61.4805 36.9198 60.746 35.9351 60.3525 35.8827C60.3525 35.8775 59.8961 36.0555 59.2508 36.9198Z",
    fill: "url(#paint222_radial_578_447510)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4944 40.2582C51.4548 40.3164 51.4549 40.3929 51.4946 40.4511C51.6965 40.7466 51.9209 41.0302 52.1624 41.2966C52.1765 41.3106 52.1906 41.3317 52.2117 41.3458C52.2892 41.4301 52.3737 41.5145 52.4583 41.5988C52.6555 41.7956 52.8527 41.9784 53.0711 42.1471C53.2459 42.2914 53.4258 42.4255 53.6153 42.5536C53.6737 42.5931 53.7502 42.593 53.8077 42.5521C54.1478 42.31 54.6407 41.887 55.0582 41.464C55.4074 41.1103 55.7634 40.648 55.9135 40.4476C55.9582 40.3878 55.9589 40.3067 55.9159 40.2457C55.8302 40.1243 55.6866 39.9234 55.5928 39.8064C55.3956 39.5604 55.1843 39.3215 54.9659 39.0965C54.8462 38.977 54.7264 38.8646 54.5996 38.7521C54.3476 38.532 54.0843 38.3288 53.8097 38.1375C53.7509 38.0965 53.673 38.0961 53.6138 38.1364C53.4161 38.271 53.2243 38.4115 53.0429 38.5623C52.8386 38.731 52.6484 38.9068 52.4653 39.0895C52.0992 39.4613 51.7756 39.8453 51.4944 40.2582Z",
    fill: "#1C7663"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0139 40.3522C52.1765 40.5984 52.3602 40.8341 52.5595 41.0541C52.57 41.0645 52.5805 41.0802 52.5962 41.0907C52.6539 41.1536 52.7169 41.2164 52.7799 41.2793C52.9267 41.4259 53.0736 41.5621 53.2363 41.6878C53.3884 41.8135 53.5458 41.9288 53.7137 42.0388C53.9655 41.8712 54.2016 41.6878 54.4272 41.4888C54.7892 41.164 55.1092 40.7974 55.382 40.3889C55.3925 40.3731 55.403 40.3627 55.4082 40.347C55.3138 40.2108 55.2193 40.0746 55.1144 39.9436C54.9675 39.7603 54.8101 39.5822 54.6475 39.4146C54.5583 39.3256 54.4691 39.2418 54.3747 39.158C54.1649 38.9746 53.9445 38.807 53.7137 38.6499C53.5406 38.7651 53.3727 38.8856 53.2153 39.0165C53.0631 39.1423 52.9215 39.2732 52.7851 39.4094C52.4913 39.7079 52.2342 40.017 52.0139 40.3522Z",
    fill: "url(#paint223_radial_578_447510)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0135 40.3525H53.708V38.6659C53.3723 38.8859 53.0575 39.1425 52.7742 39.4254C52.4909 39.7082 52.2338 40.0172 52.0135 40.3525Z",
    fill: "url(#paint224_radial_578_447510)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7088 38.6659V40.3577H55.4033C55.183 40.0225 54.9259 39.7082 54.6426 39.4254C54.3541 39.1425 54.0446 38.8859 53.7088 38.6659Z",
    fill: "url(#paint225_radial_578_447510)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7088 40.3525V42.0443C54.3803 41.5991 54.9574 41.023 55.4033 40.3525H53.7088Z",
    fill: "url(#paint226_radial_578_447510)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0135 40.3525C52.2338 40.6878 52.4909 41.002 52.7742 41.2849C53.0575 41.5677 53.3723 41.8244 53.708 42.0443V40.3525H52.0135Z",
    fill: "url(#paint227_radial_578_447510)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0143 40.3522C52.2346 40.6874 52.4917 41.0016 52.775 41.2845C53.0583 41.5673 53.373 41.824 53.7088 42.044C53.9606 41.8764 54.0498 41.8187 54.2754 41.6197L53.2104 39.0322C53.0583 39.1579 52.9166 39.2889 52.7802 39.4251C52.4917 39.7079 52.2346 40.0169 52.0143 40.3522Z",
    fill: "url(#paint228_radial_578_447510)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5912 41.0957C52.6489 41.1585 52.7119 41.2214 52.7748 41.2842C53.0581 41.5671 53.3729 41.8237 53.7087 42.0437C53.9605 41.8761 54.1966 41.6928 54.4221 41.4937C54.7841 41.169 55.1042 40.8023 55.377 40.3938C54.6687 40.6033 53.63 40.8914 52.5912 41.0957Z",
    fill: "url(#paint229_radial_578_447510)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5594 41.0542C52.5699 41.0647 52.5804 41.0804 52.5961 41.0909C52.6539 41.1537 52.7168 41.2166 52.7798 41.2794C52.9267 41.4261 53.0736 41.5623 53.2362 41.688C53.6349 40.9809 54.0756 40.1324 54.1123 39.8024C54.1071 39.8076 53.2257 40.5357 52.5594 41.0542Z",
    fill: "url(#paint230_radial_578_447510)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7086 40.3524L55.1094 39.9491C54.9625 39.7658 54.8051 39.5877 54.6425 39.4201C54.5533 39.3311 54.4641 39.2473 54.3697 39.1635L53.7086 40.3524Z",
    fill: "url(#paint231_radial_578_447510)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7078 41.4684C54.1484 41.175 54.5314 40.7979 54.8252 40.3527C54.5314 39.9127 54.1537 39.5304 53.7078 39.2371C53.2671 39.5304 52.8841 39.9075 52.5903 40.3527C52.8841 40.7979 53.2618 41.175 53.7078 41.4684Z",
    fill: "url(#paint232_radial_578_447510)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1086 40.0274C54.9617 39.8441 54.8043 39.666 54.6416 39.4984C54.5525 39.4094 54.4633 39.3256 54.3688 39.2418C54.159 39.0585 53.9387 38.8908 53.7078 38.7337C53.5347 38.8489 53.3668 38.9694 53.2094 39.1004C53.0573 39.2261 52.9156 39.357 52.7792 39.4932C52.5064 39.7656 52.2599 40.0641 52.0448 40.3836C52.0343 40.3679 52.029 40.3574 52.0185 40.3417C52.2389 40.0065 52.4959 39.6922 52.7792 39.4094C52.9156 39.2732 53.0625 39.1423 53.2094 39.0165C53.3668 38.8856 53.5347 38.7599 53.7078 38.6499C53.9387 38.8018 54.159 38.9746 54.3688 39.158C54.4633 39.2418 54.5525 39.3256 54.6416 39.4146C54.8095 39.5822 54.9669 39.7551 55.1086 39.9436C55.2135 40.0746 55.3079 40.2108 55.4023 40.347C55.3919 40.3627 55.3866 40.3731 55.3761 40.3889C55.2869 40.2684 55.1977 40.1479 55.1086 40.0274Z",
    fill: "url(#paint233_radial_578_447510)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5595 40.9756C52.57 40.9861 52.5805 41.0018 52.5962 41.0123C52.6539 41.0751 52.7169 41.138 52.7799 41.2009C52.9267 41.3475 53.0736 41.4837 53.2363 41.6094C53.3884 41.7351 53.5458 41.8503 53.7137 41.9603C53.9655 41.7927 54.2016 41.6094 54.4272 41.4104C54.7892 41.0856 55.1092 40.719 55.382 40.3104C55.3925 40.3261 55.403 40.3366 55.4082 40.3523C55.3977 40.368 55.3872 40.3785 55.382 40.3942C55.1092 40.7975 54.7892 41.1642 54.4272 41.4942C54.2068 41.6932 53.9655 41.8818 53.7137 42.0441C53.551 41.9341 53.3884 41.8189 53.2363 41.6932C53.0789 41.5623 52.9267 41.4261 52.7799 41.2847C52.7169 41.2218 52.6592 41.1589 52.5962 41.0961C52.5857 41.0856 52.5753 41.0699 52.5595 41.0594C52.3602 40.8394 52.1818 40.6037 52.0139 40.3576C52.0244 40.3419 52.0349 40.3314 52.0401 40.3157C52.1975 40.5461 52.3706 40.7661 52.5595 40.9756Z",
    fill: "url(#paint234_radial_578_447510)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.642 39.4984C54.8047 39.666 54.9621 39.8441 55.109 40.0274L55.3517 40.3553C55.0856 40.7459 54.7758 41.0976 54.4272 41.4104C54.2016 41.6094 53.9655 41.7928 53.7137 41.9604C53.5458 41.8504 53.3884 41.7352 53.2363 41.6094C53.0736 41.4837 52.9267 41.3476 52.7799 41.2009C52.7169 41.138 52.6539 41.0752 52.5962 41.0123C52.5855 41.0052 52.5772 40.9956 52.5696 40.9869C52.5662 40.9828 52.5628 40.979 52.5595 40.9757C52.3809 40.7775 52.2163 40.57 52.0659 40.3531C52.276 40.0451 52.5155 39.7569 52.7796 39.4932C52.916 39.357 53.0577 39.2261 53.2098 39.1004C53.3672 38.9694 53.5351 38.8489 53.7082 38.7337C53.9391 38.8908 54.1594 39.0585 54.3692 39.2418C54.4637 39.3256 54.5529 39.4094 54.642 39.4984ZM52.022 40.3463C52.021 40.3448 52.02 40.3433 52.0189 40.3417C52.2393 40.0065 52.4964 39.6922 52.7796 39.4094C52.916 39.2732 53.0629 39.1423 53.2098 39.0165C53.3672 38.8856 53.5351 38.7599 53.7082 38.6499C53.9391 38.8018 54.1594 38.9746 54.3692 39.158C54.4637 39.2418 54.5529 39.3256 54.642 39.4146C54.8099 39.5822 54.9673 39.7551 55.109 39.9436C55.2054 40.064 55.2929 40.1887 55.3797 40.3138C55.3805 40.3127 55.3812 40.3116 55.382 40.3105C55.3851 40.3152 55.3882 40.3194 55.3912 40.3234C55.3983 40.3329 55.4045 40.3413 55.4082 40.3524C55.4051 40.3571 55.4019 40.3613 55.3989 40.3653C55.3919 40.3748 55.3857 40.3832 55.382 40.3943C55.1092 40.7976 54.7892 41.1642 54.4272 41.4942C54.2068 41.6932 53.9655 41.8818 53.7137 42.0442C53.551 41.9342 53.3884 41.819 53.2363 41.6932C53.0789 41.5623 52.9267 41.4261 52.7799 41.2847C52.7484 41.2533 52.7182 41.2218 52.688 41.1904C52.6579 41.159 52.6277 41.1276 52.5962 41.0961C52.5929 41.0928 52.5896 41.089 52.5861 41.0849C52.5786 41.0762 52.5703 41.0666 52.5595 41.0595C52.3602 40.8395 52.1818 40.6038 52.0139 40.3576C52.0166 40.3535 52.0193 40.3498 52.022 40.3463Z",
    fill: "url(#paint235_radial_578_447510)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M53.708 39.2413C53.708 39.2413 53.047 39.6551 52.5906 40.357C52.5906 40.3517 52.9158 39.6289 53.708 39.2413Z",
    fill: "url(#paint236_radial_578_447510)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8203 40.3528C54.8203 40.3528 54.4268 41.0442 53.7606 41.458L53.7081 41.9608L53.6714 41.4475C53.6714 41.4475 53.173 41.238 52.5907 40.3528C52.5907 40.3528 53.3251 41.3375 53.7186 41.3899C53.7186 41.3951 54.175 41.217 54.8203 40.3528Z",
    fill: "url(#paint237_radial_578_447510)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7031 41.4631C53.7031 41.4631 53.0106 41.0703 52.5962 40.4051L52.0925 40.3527L52.6067 40.316C52.6067 40.316 52.8165 39.8185 53.7031 39.2371C53.7031 39.2371 52.7168 39.9704 52.6644 40.3632C52.6591 40.3632 52.8375 40.8189 53.7031 41.4631Z",
    fill: "url(#paint238_radial_578_447510)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7293 39.2371C53.7293 39.2371 54.4218 39.6299 54.8362 40.2951L55.3398 40.3475L54.8257 40.3841C54.8257 40.3841 54.6159 40.8817 53.7293 41.4631C53.7293 41.4631 54.7155 40.7298 54.768 40.337C54.7733 40.337 54.5949 39.8813 53.7293 39.2371Z",
    fill: "url(#paint239_radial_578_447510)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5907 40.3468C52.5907 40.3468 52.9841 39.6554 53.6504 39.2416L53.7029 38.7388L53.7396 39.2521C53.7396 39.2521 54.238 39.4616 54.8203 40.3468C54.8203 40.3468 54.0858 39.3621 53.6924 39.3097C53.6924 39.3045 53.236 39.4825 52.5907 40.3468Z",
    fill: "url(#paint240_radial_578_447510)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8352 43.4165C44.7956 43.4748 44.7957 43.5512 44.8354 43.6094C45.0374 43.9049 45.2617 44.1885 45.5032 44.4549C45.5173 44.469 45.5314 44.49 45.5525 44.5041C45.63 44.5884 45.7145 44.6728 45.7991 44.7571C45.9963 44.9539 46.1935 45.1367 46.4119 45.3054C46.5867 45.4497 46.7666 45.5838 46.9562 45.7119C47.0145 45.7514 47.0911 45.7513 47.1485 45.7104C47.4886 45.4683 47.9815 45.0453 48.399 44.6223C48.7482 44.2686 49.1043 43.8064 49.2543 43.6059C49.2991 43.5461 49.2997 43.4651 49.2567 43.404C49.1711 43.2827 49.0274 43.0817 48.9337 42.9648C48.7364 42.7188 48.5251 42.4798 48.3067 42.2549C48.187 42.1354 48.0672 42.0229 47.9405 41.9104C47.6884 41.6904 47.4251 41.4872 47.1505 41.2958C47.0917 41.2549 47.0138 41.2545 46.9546 41.2948C46.7569 41.4293 46.5651 41.5698 46.3837 41.7207C46.1795 41.8894 45.9893 42.0651 45.8061 42.2478C45.44 42.6197 45.1164 43.0036 44.8352 43.4165Z",
    fill: "#1C7663"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3547 43.5105C45.5174 43.7567 45.701 43.9924 45.9003 44.2124C45.9108 44.2229 45.9213 44.2386 45.9371 44.249C45.9948 44.3119 46.0577 44.3748 46.1207 44.4376C46.2676 44.5843 46.4145 44.7204 46.5771 44.8462C46.7292 44.9719 46.8866 45.0871 47.0545 45.1971C47.3063 45.0295 47.5424 44.8462 47.768 44.6471C48.13 44.3224 48.45 43.9557 48.7228 43.5472C48.7333 43.5315 48.7438 43.521 48.749 43.5053C48.6546 43.3691 48.5602 43.2329 48.4552 43.102C48.3083 42.9186 48.151 42.7406 47.9883 42.5729C47.8991 42.4839 47.81 42.4001 47.7155 42.3163C47.5057 42.133 47.2853 41.9654 47.0545 41.8082C46.8814 41.9235 46.7135 42.0439 46.5561 42.1749C46.404 42.3006 46.2623 42.4315 46.1259 42.5677C45.8321 42.8663 45.5751 43.1753 45.3547 43.5105Z",
    fill: "url(#paint241_radial_578_447510)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3543 43.5108H47.0488V41.8242C46.7131 42.0442 46.3983 42.3009 46.115 42.5837C45.8317 42.8665 45.5746 43.1756 45.3543 43.5108Z",
    fill: "url(#paint242_radial_578_447510)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0496 41.8242V43.516H48.7441C48.5238 43.1808 48.2667 42.8665 47.9834 42.5837C47.6949 42.3009 47.3854 42.0442 47.0496 41.8242Z",
    fill: "url(#paint243_radial_578_447510)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0496 43.5109V45.2027C47.7211 44.7575 48.2982 44.1813 48.7441 43.5109H47.0496Z",
    fill: "url(#paint244_radial_578_447510)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3543 43.5109C45.5746 43.8461 45.8317 44.1604 46.115 44.4432C46.3983 44.726 46.7131 44.9827 47.0488 45.2027V43.5109H45.3543Z",
    fill: "url(#paint245_radial_578_447510)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3551 43.5105C45.5754 43.8457 45.8325 44.16 46.1158 44.4428C46.3991 44.7257 46.7139 44.9823 47.0496 45.2023C47.3014 45.0347 47.3906 44.9771 47.6162 44.778L46.5512 42.1906C46.3991 42.3163 46.2574 42.4472 46.121 42.5834C45.8325 42.8662 45.5754 43.1753 45.3551 43.5105Z",
    fill: "url(#paint246_radial_578_447510)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M45.932 44.254C45.9897 44.3168 46.0527 44.3797 46.1157 44.4426C46.399 44.7254 46.7137 44.982 47.0495 45.202C47.3013 45.0344 47.5374 44.8511 47.763 44.6521C48.125 44.3273 48.445 43.9607 48.7178 43.5521C48.0095 43.7616 46.9708 44.0497 45.932 44.254Z",
    fill: "url(#paint247_radial_578_447510)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9002 44.2125C45.9107 44.223 45.9212 44.2387 45.937 44.2492C45.9947 44.312 46.0576 44.3749 46.1206 44.4378C46.2675 44.5844 46.4144 44.7206 46.577 44.8463C46.9757 44.1392 47.4164 43.2907 47.4531 42.9607C47.4479 42.9659 46.5665 43.694 45.9002 44.2125Z",
    fill: "url(#paint248_radial_578_447510)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0495 43.5108L48.4502 43.1074C48.3033 42.9241 48.1459 42.746 47.9833 42.5784C47.8941 42.4894 47.8049 42.4056 47.7105 42.3218L47.0495 43.5108Z",
    fill: "url(#paint249_radial_578_447510)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0486 44.6267C47.4893 44.3334 47.8722 43.9563 48.166 43.511C47.8722 43.0711 47.4945 42.6887 47.0486 42.3954C46.6079 42.6887 46.2249 43.0658 45.9311 43.511C46.2249 43.9563 46.6026 44.3334 47.0486 44.6267Z",
    fill: "url(#paint250_radial_578_447510)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4494 43.1858C48.3025 43.0024 48.1451 42.8244 47.9825 42.6568C47.8933 42.5677 47.8041 42.4839 47.7097 42.4001C47.4998 42.2168 47.2795 42.0492 47.0486 41.892C46.8755 42.0073 46.7076 42.1277 46.5502 42.2587C46.3981 42.3844 46.2565 42.5153 46.1201 42.6515C45.8473 42.9239 45.6007 43.2224 45.3856 43.5419C45.3751 43.5262 45.3699 43.5158 45.3594 43.5C45.5797 43.1648 45.8368 42.8506 46.1201 42.5677C46.2565 42.4315 46.4034 42.3006 46.5502 42.1749C46.7076 42.0439 46.8755 41.9182 47.0486 41.8082C47.2795 41.9601 47.4998 42.133 47.7097 42.3163C47.8041 42.4001 47.8933 42.4839 47.9825 42.5729C48.1503 42.7406 48.3077 42.9134 48.4494 43.102C48.5543 43.2329 48.6487 43.3691 48.7432 43.5053C48.7327 43.521 48.7274 43.5315 48.7169 43.5472C48.6277 43.4267 48.5386 43.3062 48.4494 43.1858Z",
    fill: "url(#paint251_radial_578_447510)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9003 44.134C45.9108 44.1444 45.9213 44.1601 45.9371 44.1706C45.9948 44.2335 46.0577 44.2963 46.1207 44.3592C46.2676 44.5058 46.4145 44.642 46.5771 44.7677C46.7292 44.8934 46.8866 45.0087 47.0545 45.1187C47.3063 44.951 47.5424 44.7677 47.768 44.5687C48.13 44.2439 48.45 43.8773 48.7228 43.4688C48.7333 43.4845 48.7438 43.4949 48.749 43.5107C48.7385 43.5264 48.728 43.5368 48.7228 43.5526C48.45 43.9559 48.13 44.3225 47.768 44.6525C47.5476 44.8515 47.3063 45.0401 47.0545 45.2025C46.8919 45.0925 46.7292 44.9772 46.5771 44.8515C46.4197 44.7206 46.2676 44.5844 46.1207 44.443C46.0577 44.3801 46 44.3173 45.9371 44.2544C45.9266 44.2439 45.9161 44.2282 45.9003 44.2178C45.701 43.9978 45.5226 43.7621 45.3547 43.5159C45.3652 43.5002 45.3757 43.4897 45.381 43.474C45.5383 43.7045 45.7115 43.9244 45.9003 44.134Z",
    fill: "url(#paint252_radial_578_447510)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9829 42.6568C48.1455 42.8244 48.3029 43.0024 48.4498 43.1858L48.6925 43.5137C48.4264 43.9042 48.1167 44.2559 47.768 44.5687C47.5424 44.7678 47.3063 44.9511 47.0545 45.1187C46.8866 45.0087 46.7292 44.8935 46.5771 44.7678C46.4145 44.6421 46.2676 44.5059 46.1207 44.3592C46.0577 44.2964 45.9948 44.2335 45.9371 44.1707C45.9263 44.1635 45.918 44.1539 45.9105 44.1452C45.907 44.1412 45.9037 44.1373 45.9003 44.134C45.7217 43.9358 45.5572 43.7283 45.4067 43.5114C45.6169 43.2034 45.8564 42.9152 46.1205 42.6515C46.2569 42.5153 46.3985 42.3844 46.5507 42.2587C46.708 42.1277 46.8759 42.0073 47.049 41.892C47.2799 42.0492 47.5002 42.2168 47.7101 42.4001C47.8045 42.4839 47.8937 42.5677 47.9829 42.6568ZM45.3628 43.5046C45.3618 43.5031 45.3608 43.5016 45.3598 43.5C45.5801 43.1648 45.8372 42.8506 46.1205 42.5677C46.2569 42.4315 46.4038 42.3006 46.5507 42.1749C46.708 42.0439 46.8759 41.9182 47.049 41.8082C47.2799 41.9601 47.5002 42.133 47.7101 42.3163C47.8045 42.4001 47.8937 42.4839 47.9829 42.5729C48.1507 42.7406 48.3081 42.9134 48.4498 43.102C48.5462 43.2223 48.6337 43.347 48.7206 43.4721C48.7213 43.471 48.7221 43.4699 48.7228 43.4688C48.7259 43.4735 48.7291 43.4777 48.732 43.4817C48.7391 43.4912 48.7453 43.4997 48.749 43.5107C48.7459 43.5154 48.7428 43.5196 48.7398 43.5236C48.7327 43.5331 48.7265 43.5416 48.7228 43.5526C48.45 43.9559 48.13 44.3226 47.768 44.6525C47.5476 44.8516 47.3063 45.0401 47.0545 45.2025C46.8919 45.0925 46.7292 44.9773 46.5771 44.8516C46.4197 44.7206 46.2676 44.5844 46.1207 44.443C46.0892 44.4116 46.059 44.3802 46.0289 44.3487C45.9987 44.3173 45.9685 44.2859 45.9371 44.2545C45.9337 44.2511 45.9304 44.2473 45.9269 44.2433C45.9194 44.2346 45.9111 44.225 45.9003 44.2178C45.701 43.9978 45.5226 43.7621 45.3547 43.5159C45.3574 43.5119 45.3602 43.5082 45.3628 43.5046Z",
    fill: "url(#paint253_radial_578_447510)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0488 42.3997C47.0488 42.3997 46.3878 42.8134 45.9314 43.5153C45.9314 43.5101 46.2567 42.7873 47.0488 42.3997Z",
    fill: "url(#paint254_radial_578_447510)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1611 43.5111C48.1611 43.5111 47.7677 44.2025 47.1014 44.6163L47.0489 45.1191L47.0122 44.6058C47.0122 44.6058 46.5138 44.3963 45.9315 43.5111C45.9315 43.5111 46.666 44.4958 47.0594 44.5482C47.0594 44.5534 47.5158 44.3753 48.1611 43.5111Z",
    fill: "url(#paint255_radial_578_447510)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0439 44.6215C47.0439 44.6215 46.3514 44.2286 45.937 43.5634L45.4334 43.511L45.9475 43.4744C45.9475 43.4744 46.1573 42.9768 47.0439 42.3954C47.0439 42.3954 46.0577 43.1287 46.0052 43.5215C46 43.5215 46.1783 43.9772 47.0439 44.6215Z",
    fill: "url(#paint256_radial_578_447510)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0701 42.3954C47.0701 42.3954 47.7626 42.7882 48.177 43.4534L48.6807 43.5058L48.1665 43.5425C48.1665 43.5425 47.9567 44.0401 47.0701 44.6215C47.0701 44.6215 48.0564 43.8882 48.1088 43.4953C48.1141 43.4953 47.9357 43.0396 47.0701 42.3954Z",
    fill: "url(#paint257_radial_578_447510)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9315 43.5051C45.9315 43.5051 46.325 42.8137 46.9912 42.3999L47.0437 41.8971L47.0804 42.4104C47.0804 42.4104 47.5788 42.6199 48.1611 43.5051C48.1611 43.5051 47.4267 42.5204 47.0332 42.468C47.0332 42.4628 46.5768 42.6409 45.9315 43.5051Z",
    fill: "url(#paint258_radial_578_447510)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1751 40.2582C38.1354 40.3164 38.1355 40.3929 38.1753 40.4511C38.3772 40.7466 38.6015 41.0302 38.8431 41.2966C38.8572 41.3106 38.8712 41.3317 38.8924 41.3458C38.9699 41.4301 39.0544 41.5145 39.1389 41.5988C39.3362 41.7956 39.5334 41.9784 39.7517 42.1471C39.9265 42.2914 40.1065 42.4255 40.296 42.5536C40.3544 42.5931 40.4309 42.593 40.4883 42.5521C40.8284 42.31 41.3213 41.887 41.7389 41.464C42.088 41.1103 42.4441 40.648 42.5942 40.4476C42.6389 40.3878 42.6396 40.3067 42.5965 40.2457C42.5109 40.1243 42.3672 39.9234 42.2735 39.8064C42.0763 39.5604 41.865 39.3215 41.6466 39.0965C41.5268 38.977 41.4071 38.8646 41.2803 38.7521C41.0283 38.532 40.7649 38.3288 40.4903 38.1375C40.4316 38.0965 40.3537 38.0961 40.2945 38.1364C40.0968 38.271 39.905 38.4115 39.7236 38.5623C39.5193 38.731 39.3291 38.9068 39.146 39.0895C38.7799 39.4613 38.4562 39.8453 38.1751 40.2582Z",
    fill: "#1C7663"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6946 40.3522C38.8572 40.5984 39.0408 40.8341 39.2402 41.0541C39.2507 41.0645 39.2612 41.0802 39.2769 41.0907C39.3346 41.1536 39.3976 41.2164 39.4605 41.2793C39.6074 41.4259 39.7543 41.5621 39.9169 41.6878C40.0691 41.8135 40.2265 41.9288 40.3943 42.0388C40.6462 41.8712 40.8822 41.6878 41.1078 41.4888C41.4698 41.164 41.7898 40.7974 42.0626 40.3889C42.0731 40.3731 42.0836 40.3627 42.0889 40.347C41.9944 40.2108 41.9 40.0746 41.7951 39.9436C41.6482 39.7603 41.4908 39.5822 41.3282 39.4146C41.239 39.3256 41.1498 39.2418 41.0554 39.158C40.8455 38.9746 40.6252 38.807 40.3943 38.6499C40.2212 38.7651 40.0533 38.8856 39.896 39.0165C39.7438 39.1423 39.6022 39.2732 39.4658 39.4094C39.172 39.7079 38.9149 40.017 38.6946 40.3522Z",
    fill: "url(#paint259_radial_578_447510)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6941 40.3525H40.3887V38.6659C40.0529 38.8859 39.7381 39.1425 39.4548 39.4254C39.1716 39.7082 38.9145 40.0172 38.6941 40.3525Z",
    fill: "url(#paint260_radial_578_447510)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3895 38.6659V40.3577H42.084C41.8636 40.0225 41.6066 39.7082 41.3233 39.4254C41.0347 39.1425 40.7252 38.8859 40.3895 38.6659Z",
    fill: "url(#paint261_radial_578_447510)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3895 40.3525V42.0443C41.061 41.5991 41.6381 41.023 42.084 40.3525H40.3895Z",
    fill: "url(#paint262_radial_578_447510)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6941 40.3525C38.9145 40.6878 39.1716 41.002 39.4548 41.2849C39.7381 41.5677 40.0529 41.8244 40.3887 42.0443V40.3525H38.6941Z",
    fill: "url(#paint263_radial_578_447510)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6949 40.3522C38.9153 40.6874 39.1723 41.0016 39.4556 41.2845C39.7389 41.5673 40.0537 41.824 40.3895 42.044C40.6413 41.8764 40.7305 41.8187 40.9561 41.6197L39.8911 39.0322C39.7389 39.1579 39.5973 39.2889 39.4609 39.4251C39.1723 39.7079 38.9153 40.0169 38.6949 40.3522Z",
    fill: "url(#paint264_radial_578_447510)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2719 41.0957C39.3296 41.1585 39.3925 41.2214 39.4555 41.2842C39.7388 41.5671 40.0536 41.8237 40.3893 42.0437C40.6411 41.8761 40.8772 41.6928 41.1028 41.4937C41.4648 41.169 41.7848 40.8023 42.0576 40.3938C41.3494 40.6033 40.3106 40.8914 39.2719 41.0957Z",
    fill: "url(#paint265_radial_578_447510)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2401 41.0542C39.2506 41.0647 39.2611 41.0804 39.2768 41.0909C39.3345 41.1537 39.3975 41.2166 39.4604 41.2794C39.6073 41.4261 39.7542 41.5623 39.9169 41.688C40.3156 40.9809 40.7562 40.1324 40.793 39.8024C40.7877 39.8076 39.9064 40.5357 39.2401 41.0542Z",
    fill: "url(#paint266_radial_578_447510)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3893 40.3524L41.79 39.9491C41.6431 39.7658 41.4858 39.5877 41.3231 39.4201C41.2339 39.3311 41.1448 39.2473 41.0503 39.1635L40.3893 40.3524Z",
    fill: "url(#paint267_radial_578_447510)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3884 41.4684C40.8291 41.175 41.2121 40.7979 41.5059 40.3527C41.2121 39.9127 40.8343 39.5304 40.3884 39.2371C39.9477 39.5304 39.5648 39.9075 39.271 40.3527C39.5648 40.7979 39.9425 41.175 40.3884 41.4684Z",
    fill: "url(#paint268_radial_578_447510)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7892 40.0274C41.6423 39.8441 41.4849 39.666 41.3223 39.4984C41.2331 39.4094 41.1439 39.3256 41.0495 39.2418C40.8397 39.0585 40.6193 38.8908 40.3885 38.7337C40.2154 38.8489 40.0475 38.9694 39.8901 39.1004C39.738 39.2261 39.5963 39.357 39.4599 39.4932C39.1871 39.7656 38.9405 40.0641 38.7254 40.3836C38.7149 40.3679 38.7097 40.3574 38.6992 40.3417C38.9195 40.0065 39.1766 39.6922 39.4599 39.4094C39.5963 39.2732 39.7432 39.1423 39.8901 39.0165C40.0475 38.8856 40.2154 38.7599 40.3885 38.6499C40.6193 38.8018 40.8397 38.9746 41.0495 39.158C41.1439 39.2418 41.2331 39.3256 41.3223 39.4146C41.4902 39.5822 41.6476 39.7551 41.7892 39.9436C41.8941 40.0746 41.9886 40.2108 42.083 40.347C42.0725 40.3627 42.0673 40.3731 42.0568 40.3889C41.9676 40.2684 41.8784 40.1479 41.7892 40.0274Z",
    fill: "url(#paint269_radial_578_447510)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2402 40.9756C39.2507 40.9861 39.2612 41.0018 39.2769 41.0123C39.3346 41.0751 39.3976 41.138 39.4605 41.2009C39.6074 41.3475 39.7543 41.4837 39.9169 41.6094C40.0691 41.7351 40.2265 41.8503 40.3943 41.9603C40.6462 41.7927 40.8822 41.6094 41.1078 41.4104C41.4698 41.0856 41.7898 40.719 42.0626 40.3104C42.0731 40.3261 42.0836 40.3366 42.0889 40.3523C42.0784 40.368 42.0679 40.3785 42.0626 40.3942C41.7898 40.7975 41.4698 41.1642 41.1078 41.4942C40.8875 41.6932 40.6462 41.8818 40.3943 42.0441C40.2317 41.9341 40.0691 41.8189 39.9169 41.6932C39.7596 41.5623 39.6074 41.4261 39.4605 41.2847C39.3976 41.2218 39.3399 41.1589 39.2769 41.0961C39.2664 41.0856 39.2559 41.0699 39.2402 41.0594C39.0408 40.8394 38.8624 40.6037 38.6946 40.3576C38.7051 40.3419 38.7156 40.3314 38.7208 40.3157C38.8782 40.5461 39.0513 40.7661 39.2402 40.9756Z",
    fill: "url(#paint270_radial_578_447510)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3227 39.4984C41.4853 39.666 41.6427 39.8441 41.7896 40.0274L42.0324 40.3553C41.7663 40.7459 41.4565 41.0976 41.1078 41.4104C40.8822 41.6094 40.6462 41.7928 40.3943 41.9604C40.2265 41.8504 40.0691 41.7352 39.9169 41.6094C39.7543 41.4837 39.6074 41.3476 39.4605 41.2009C39.3976 41.138 39.3346 41.0752 39.2769 41.0123C39.2661 41.0052 39.2578 40.9956 39.2503 40.9869C39.2468 40.9828 39.2435 40.979 39.2402 40.9757C39.0615 40.7775 38.897 40.57 38.7465 40.3531C38.9567 40.0451 39.1962 39.7569 39.4603 39.4932C39.5967 39.357 39.7384 39.2261 39.8905 39.1004C40.0479 38.9694 40.2158 38.8489 40.3889 38.7337C40.6197 38.8908 40.8401 39.0585 41.0499 39.2418C41.1443 39.3256 41.2335 39.4094 41.3227 39.4984ZM38.7026 40.3463C38.7017 40.3448 38.7007 40.3433 38.6996 40.3417C38.92 40.0065 39.177 39.6922 39.4603 39.4094C39.5967 39.2732 39.7436 39.1423 39.8905 39.0165C40.0479 38.8856 40.2158 38.7599 40.3889 38.6499C40.6197 38.8018 40.8401 38.9746 41.0499 39.158C41.1443 39.2418 41.2335 39.3256 41.3227 39.4146C41.4906 39.5822 41.648 39.7551 41.7896 39.9436C41.886 40.064 41.9736 40.1887 42.0604 40.3138C42.0612 40.3127 42.0619 40.3116 42.0626 40.3105C42.0658 40.3152 42.0689 40.3194 42.0719 40.3234C42.0789 40.3329 42.0852 40.3413 42.0889 40.3524C42.0857 40.3571 42.0826 40.3613 42.0796 40.3653C42.0726 40.3748 42.0663 40.3832 42.0626 40.3943C41.7898 40.7976 41.4698 41.1642 41.1078 41.4942C40.8875 41.6932 40.6462 41.8818 40.3943 42.0442C40.2317 41.9342 40.0691 41.819 39.9169 41.6932C39.7596 41.5623 39.6074 41.4261 39.4605 41.2847C39.429 41.2533 39.3989 41.2218 39.3687 41.1904C39.3385 41.159 39.3084 41.1276 39.2769 41.0961C39.2736 41.0928 39.2703 41.089 39.2668 41.0849C39.2592 41.0762 39.2509 41.0666 39.2402 41.0595C39.0408 40.8395 38.8624 40.6038 38.6946 40.3576C38.6973 40.3535 38.7 40.3498 38.7026 40.3463Z",
    fill: "url(#paint271_radial_578_447510)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3887 39.2413C40.3887 39.2413 39.7277 39.6551 39.2712 40.357C39.2712 40.3517 39.5965 39.6289 40.3887 39.2413Z",
    fill: "url(#paint272_radial_578_447510)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M41.501 40.3528C41.501 40.3528 41.1075 41.0442 40.4412 41.458L40.3888 41.9608L40.3521 41.4475C40.3521 41.4475 39.8537 41.238 39.2713 40.3528C39.2713 40.3528 40.0058 41.3375 40.3993 41.3899C40.3993 41.3951 40.8557 41.217 41.501 40.3528Z",
    fill: "url(#paint273_radial_578_447510)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3838 41.4631C40.3838 41.4631 39.6913 41.0703 39.2768 40.4051L38.7732 40.3527L39.2873 40.316C39.2873 40.316 39.4972 39.8185 40.3838 39.2371C40.3838 39.2371 39.3975 39.9704 39.345 40.3632C39.3398 40.3632 39.5182 40.8189 40.3838 41.4631Z",
    fill: "url(#paint274_radial_578_447510)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4099 39.2371C40.4099 39.2371 41.1024 39.6299 41.5169 40.2951L42.0205 40.3475L41.5064 40.3841C41.5064 40.3841 41.2965 40.8817 40.4099 41.4631C40.4099 41.4631 41.3962 40.7298 41.4487 40.337C41.4539 40.337 41.2755 39.8813 40.4099 39.2371Z",
    fill: "url(#paint275_radial_578_447510)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2713 40.3468C39.2713 40.3468 39.6648 39.6554 40.3311 39.2416L40.3835 38.7388L40.4203 39.2521C40.4203 39.2521 40.9186 39.4616 41.501 40.3468C41.501 40.3468 40.7665 39.3621 40.373 39.3097C40.373 39.3045 39.9166 39.4825 39.2713 40.3468Z",
    fill: "url(#paint276_radial_578_447510)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4798 36.8312C31.4401 36.8894 31.4402 36.9659 31.4799 37.0241C31.6819 37.3196 31.9062 37.6032 32.1478 37.8696C32.1618 37.8836 32.1759 37.9047 32.1971 37.9188C32.2746 38.0031 32.3591 38.0875 32.4436 38.1718C32.6408 38.3686 32.8381 38.5514 33.0564 38.7201C33.2312 38.8644 33.4112 38.9985 33.6007 39.1266C33.6591 39.1661 33.7356 39.1659 33.793 39.1251C34.1331 38.883 34.626 38.46 35.0436 38.037C35.3927 37.6833 35.7488 37.221 35.8988 37.0206C35.9436 36.9608 35.9443 36.8797 35.9012 36.8187C35.8156 36.6973 35.6719 36.4964 35.5782 36.3794C35.381 36.1334 35.1696 35.8945 34.9513 35.6695C34.8315 35.55 34.7118 35.4376 34.585 35.3251C34.3329 35.105 34.0696 34.9018 33.795 34.7105C33.7363 34.6695 33.6584 34.6691 33.5992 34.7094C33.4014 34.844 33.2097 34.9845 33.0283 35.1353C32.824 35.304 32.6338 35.4797 32.4507 35.6625C32.0845 36.0343 31.7609 36.4183 31.4798 36.8312Z",
    fill: "#1C7663"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9993 36.9252C32.1619 37.1714 32.3455 37.4071 32.5449 37.6271C32.5554 37.6375 32.5658 37.6532 32.5816 37.6637C32.6393 37.7266 32.7022 37.7894 32.7652 37.8523C32.9121 37.9989 33.059 38.1351 33.2216 38.2608C33.3738 38.3865 33.5312 38.5018 33.699 38.6118C33.9508 38.4442 34.1869 38.2608 34.4125 38.0618C34.7745 37.737 35.0945 37.3704 35.3673 36.9619C35.3778 36.9461 35.3883 36.9357 35.3936 36.9199C35.2991 36.7838 35.2047 36.6476 35.0998 36.5166C34.9529 36.3333 34.7955 36.1552 34.6329 35.9876C34.5437 35.8986 34.4545 35.8148 34.3601 35.731C34.1502 35.5476 33.9299 35.38 33.699 35.2229C33.5259 35.3381 33.358 35.4586 33.2006 35.5895C33.0485 35.7153 32.9069 35.8462 32.7704 35.9824C32.4767 36.2809 32.2196 36.59 31.9993 36.9252Z",
    fill: "url(#paint277_radial_578_447510)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9988 36.9255H33.6934V35.2389C33.3576 35.4589 33.0428 35.7155 32.7595 35.9984C32.4762 36.2812 32.2192 36.5902 31.9988 36.9255Z",
    fill: "url(#paint278_radial_578_447510)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6941 35.2389V36.9307H35.3887C35.1683 36.5955 34.9113 36.2812 34.628 35.9984C34.3394 35.7155 34.0299 35.4589 33.6941 35.2389Z",
    fill: "url(#paint279_radial_578_447510)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6941 36.9255V38.6173C34.3657 38.1721 34.9427 37.596 35.3887 36.9255H33.6941Z",
    fill: "url(#paint280_radial_578_447510)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9988 36.9255C32.2192 37.2608 32.4762 37.575 32.7595 37.8579C33.0428 38.1407 33.3576 38.3974 33.6934 38.6173V36.9255H31.9988Z",
    fill: "url(#paint281_radial_578_447510)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9996 36.9252C32.22 37.2604 32.477 37.5746 32.7603 37.8575C33.0436 38.1403 33.3584 38.397 33.6942 38.617C33.946 38.4494 34.0352 38.3917 34.2607 38.1927L33.1958 35.6052C33.0436 35.7309 32.902 35.8619 32.7656 35.9981C32.477 36.2809 32.22 36.5899 31.9996 36.9252Z",
    fill: "url(#paint282_radial_578_447510)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5766 37.6687C32.6343 37.7315 32.6972 37.7944 32.7602 37.8572C33.0435 38.1401 33.3583 38.3967 33.694 38.6167C33.9458 38.4491 34.1819 38.2658 34.4075 38.0667C34.7695 37.742 35.0895 37.3753 35.3623 36.9668C34.6541 37.1763 33.6153 37.4644 32.5766 37.6687Z",
    fill: "url(#paint283_radial_578_447510)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5448 37.6272C32.5553 37.6377 32.5658 37.6534 32.5815 37.6639C32.6392 37.7267 32.7022 37.7896 32.7651 37.8524C32.912 37.9991 33.0589 38.1353 33.2215 38.261C33.6203 37.5539 34.0609 36.7053 34.0977 36.3754C34.0924 36.3806 33.211 37.1087 32.5448 37.6272Z",
    fill: "url(#paint284_radial_578_447510)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M33.694 36.9254L35.0947 36.5221C34.9478 36.3388 34.7904 36.1607 34.6278 35.9931C34.5386 35.9041 34.4494 35.8203 34.355 35.7365L33.694 36.9254Z",
    fill: "url(#paint285_radial_578_447510)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6931 38.0414C34.1338 37.748 34.5168 37.3709 34.8105 36.9257C34.5168 36.4857 34.139 36.1034 33.6931 35.8101C33.2524 36.1034 32.8695 36.4805 32.5757 36.9257C32.8695 37.3709 33.2472 37.748 33.6931 38.0414Z",
    fill: "url(#paint286_radial_578_447510)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0939 36.6004C34.947 36.4171 34.7896 36.239 34.627 36.0714C34.5378 35.9824 34.4486 35.8986 34.3542 35.8148C34.1443 35.6314 33.924 35.4638 33.6932 35.3067C33.52 35.4219 33.3522 35.5424 33.1948 35.6734C33.0426 35.7991 32.901 35.93 32.7646 36.0662C32.4918 36.3386 32.2452 36.6371 32.0301 36.9566C32.0196 36.9409 32.0144 36.9304 32.0039 36.9147C32.2242 36.5795 32.4813 36.2652 32.7646 35.9824C32.901 35.8462 33.0479 35.7153 33.1948 35.5895C33.3522 35.4586 33.52 35.3329 33.6932 35.2229C33.924 35.3748 34.1443 35.5476 34.3542 35.731C34.4486 35.8148 34.5378 35.8986 34.627 35.9876C34.7949 36.1552 34.9523 36.3281 35.0939 36.5166C35.1988 36.6476 35.2933 36.7838 35.3877 36.9199C35.3772 36.9357 35.372 36.9461 35.3615 36.9619C35.2723 36.8414 35.1831 36.7209 35.0939 36.6004Z",
    fill: "url(#paint287_radial_578_447510)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5449 37.5486C32.5554 37.5591 32.5658 37.5748 32.5816 37.5853C32.6393 37.6481 32.7022 37.711 32.7652 37.7739C32.9121 37.9205 33.059 38.0567 33.2216 38.1824C33.3738 38.3081 33.5312 38.4233 33.699 38.5333C33.9508 38.3657 34.1869 38.1824 34.4125 37.9834C34.7745 37.6586 35.0945 37.292 35.3673 36.8834C35.3778 36.8991 35.3883 36.9096 35.3936 36.9253C35.3831 36.941 35.3726 36.9515 35.3673 36.9672C35.0945 37.3705 34.7745 37.7372 34.4125 38.0672C34.1922 38.2662 33.9508 38.4548 33.699 38.6171C33.5364 38.5071 33.3738 38.3919 33.2216 38.2662C33.0642 38.1353 32.9121 37.9991 32.7652 37.8577C32.7022 37.7948 32.6445 37.7319 32.5816 37.6691C32.5711 37.6586 32.5606 37.6429 32.5449 37.6324C32.3455 37.4124 32.1671 37.1767 31.9993 36.9306C32.0098 36.9148 32.0202 36.9044 32.0255 36.8887C32.1829 37.1191 32.356 37.3391 32.5449 37.5486Z",
    fill: "url(#paint288_radial_578_447510)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6274 36.0714C34.79 36.239 34.9474 36.4171 35.0943 36.6004L35.3371 36.9283C35.0709 37.3189 34.7612 37.6706 34.4125 37.9834C34.1869 38.1824 33.9508 38.3658 33.699 38.5334C33.5312 38.4234 33.3738 38.3082 33.2216 38.1824C33.059 38.0567 32.9121 37.9206 32.7652 37.7739C32.7022 37.711 32.6393 37.6482 32.5816 37.5853C32.5708 37.5782 32.5625 37.5686 32.555 37.5599C32.5515 37.5558 32.5482 37.552 32.5449 37.5487C32.3662 37.3505 32.2017 37.143 32.0512 36.9261C32.2614 36.6181 32.5009 36.3299 32.765 36.0662C32.9014 35.93 33.043 35.7991 33.1952 35.6734C33.3526 35.5424 33.5205 35.4219 33.6936 35.3067C33.9244 35.4638 34.1448 35.6314 34.3546 35.8148C34.449 35.8986 34.5382 35.9824 34.6274 36.0714ZM32.0073 36.9193C32.0063 36.9178 32.0053 36.9163 32.0043 36.9147C32.2246 36.5795 32.4817 36.2652 32.765 35.9824C32.9014 35.8462 33.0483 35.7153 33.1952 35.5895C33.3526 35.4586 33.5205 35.3329 33.6936 35.2229C33.9244 35.3748 34.1448 35.5476 34.3546 35.731C34.449 35.8148 34.5382 35.8986 34.6274 35.9876C34.7953 36.1552 34.9527 36.3281 35.0943 36.5166C35.1907 36.637 35.2783 36.7617 35.3651 36.8868C35.3658 36.8857 35.3666 36.8846 35.3673 36.8835C35.3705 36.8882 35.3736 36.8924 35.3766 36.8964C35.3836 36.9059 35.3899 36.9143 35.3936 36.9254C35.3904 36.9301 35.3873 36.9343 35.3843 36.9383C35.3773 36.9478 35.371 36.9562 35.3673 36.9673C35.0945 37.3706 34.7745 37.7372 34.4125 38.0672C34.1922 38.2662 33.9508 38.4548 33.699 38.6172C33.5364 38.5072 33.3738 38.392 33.2216 38.2662C33.0642 38.1353 32.9121 37.9991 32.7652 37.8577C32.7337 37.8263 32.7036 37.7948 32.6734 37.7634C32.6432 37.732 32.6131 37.7006 32.5816 37.6691C32.5783 37.6658 32.5749 37.662 32.5715 37.6579C32.5639 37.6492 32.5556 37.6396 32.5449 37.6325C32.3455 37.4125 32.1671 37.1768 31.9993 36.9306C32.002 36.9265 32.0047 36.9228 32.0073 36.9193Z",
    fill: "url(#paint289_radial_578_447510)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6934 35.8143C33.6934 35.8143 33.0323 36.2281 32.5759 36.93C32.5759 36.9247 32.9012 36.2019 33.6934 35.8143Z",
    fill: "url(#paint290_radial_578_447510)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8057 36.9258C34.8057 36.9258 34.4122 37.6172 33.7459 38.031L33.6935 38.5338L33.6567 38.0205C33.6567 38.0205 33.1584 37.811 32.576 36.9258C32.576 36.9258 33.3105 37.9105 33.704 37.9629C33.704 37.9681 34.1604 37.79 34.8057 36.9258Z",
    fill: "url(#paint291_radial_578_447510)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6885 38.0361C33.6885 38.0361 32.996 37.6433 32.5815 36.9781L32.0779 36.9257L32.592 36.889C32.592 36.889 32.8019 36.3915 33.6885 35.8101C33.6885 35.8101 32.7022 36.5434 32.6497 36.9362C32.6445 36.9362 32.8229 37.3919 33.6885 38.0361Z",
    fill: "url(#paint292_radial_578_447510)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7146 35.8101C33.7146 35.8101 34.4071 36.2029 34.8216 36.8681L35.3252 36.9205L34.8111 36.9571C34.8111 36.9571 34.6012 37.4547 33.7146 38.0361C33.7146 38.0361 34.7009 37.3028 34.7534 36.91C34.7586 36.91 34.5802 36.4543 33.7146 35.8101Z",
    fill: "url(#paint293_radial_578_447510)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M32.576 36.9198C32.576 36.9198 32.9695 36.2284 33.6358 35.8146L33.6882 35.3118L33.7249 35.8251C33.7249 35.8251 34.2233 36.0346 34.8057 36.9198C34.8057 36.9198 34.0712 35.9351 33.6777 35.8827C33.6777 35.8775 33.2213 36.0555 32.576 36.9198Z",
    fill: "url(#paint294_radial_578_447510)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M43.751 19.0642C44.0867 19.0771 44.5644 19.1029 44.7968 19.1158C45.0292 19.1287 45.2228 19.1287 45.3648 19.1287C45.5327 19.1287 45.8813 19.1158 46.3977 19.0771C46.5914 19.0642 46.7334 19.0642 46.8366 19.0642V19.6968C46.5526 19.7097 46.359 19.7485 46.2686 19.8001C46.1782 19.8518 46.1395 19.9422 46.1395 20.0713C46.1395 20.1358 46.1524 20.2133 46.1653 20.2907C46.1782 20.3811 46.2169 20.4715 46.2557 20.5877L47.8824 25.5325L49.4059 20.6006C49.4575 20.4844 49.4834 20.394 49.4963 20.3295C49.5092 20.2649 49.5092 20.2004 49.5092 20.1229C49.5092 19.968 49.4575 19.8647 49.3413 19.7872C49.2251 19.7227 49.0315 19.684 48.7733 19.684V19.0513C49.0315 19.0642 49.2251 19.0771 49.393 19.09C49.5608 19.103 49.6899 19.103 49.8061 19.103C49.8965 19.103 50.0127 19.103 50.1548 19.09C50.2968 19.0771 50.5808 19.0771 50.839 19.0513V19.684C50.5937 19.7098 50.4259 19.7485 50.3355 19.8131C50.2451 19.8776 50.1676 19.9938 50.1289 20.1616L48.3859 25.3002C48.2827 25.61 48.2181 25.8553 48.089 26.1781C47.9728 26.5137 47.8825 26.6945 47.7663 27.0431L46.9787 26.9786L44.5902 20.3811L44.5773 20.3424C44.4223 19.8905 44.1512 19.671 43.7639 19.671V19.0642H43.751Z",
    fill: "url(#paint295_linear_578_447510)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3896 19.2703C43.7382 19.2832 44.0352 19.309 44.2805 19.3219C44.5259 19.3348 44.7195 19.3348 44.8615 19.3348C45.0423 19.3348 45.3909 19.3219 45.9331 19.2961C46.1397 19.2832 46.2817 19.2832 46.385 19.2832V19.7092C46.088 19.7221 45.8944 19.7609 45.804 19.8125C45.7136 19.8642 45.6749 19.9545 45.6749 20.0836C45.6749 20.1482 45.6878 20.2128 45.7007 20.3031C45.7136 20.3935 45.7523 20.4839 45.7911 20.6001L47.4824 25.4675L49.0704 20.613C49.1221 20.4968 49.1479 20.4064 49.1608 20.3418C49.1737 20.2902 49.1737 20.2128 49.1737 20.1353C49.1737 19.9804 49.1221 19.8771 48.993 19.8125C48.8639 19.748 48.6702 19.7092 48.3862 19.7092V19.2832C48.6573 19.2961 48.8639 19.309 49.0317 19.3219C49.1995 19.3348 49.3415 19.3348 49.4577 19.3348C49.5481 19.3348 49.6643 19.3348 49.8193 19.3219C49.9742 19.309 50.3744 19.309 50.6456 19.2832V19.7092C50.3873 19.735 50.2195 19.7738 50.1162 19.8383C50.0258 19.9029 49.9484 20.0191 49.8968 20.1869L48.1667 25.2479C48.0634 25.5449 47.9472 25.8548 47.831 26.1776C47.7019 26.5003 47.5857 26.836 47.4437 27.1846L46.7207 27.12L44.2547 20.4064L44.2418 20.3677C44.0868 19.9287 43.8028 19.6963 43.4026 19.6963L43.3896 19.2703Z",
    fill: "url(#paint296_radial_578_447510)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6221 19.2579C43.9707 19.2708 44.2676 19.2967 44.5129 19.3096C44.7582 19.3225 44.9519 19.3225 45.0939 19.3225C45.2746 19.3225 45.6232 19.3096 46.1655 19.2838C46.372 19.2709 46.5141 19.2709 46.6173 19.2709V19.6969C46.3204 19.7098 46.1267 19.7486 46.0364 19.7873C45.946 19.8389 45.9072 19.9293 45.9072 20.0584C45.9072 20.123 45.9202 20.1876 45.9331 20.265C45.946 20.3425 45.9848 20.4328 46.0235 20.549L47.7148 25.3131L49.3028 20.5619C49.3545 20.4457 49.3803 20.3554 49.3932 20.2908C49.4061 20.2262 49.4061 20.1617 49.4061 20.0971C49.4061 19.9551 49.3545 19.8518 49.2254 19.7873C49.0962 19.7227 48.9026 19.6969 48.6185 19.6969V19.2709C48.8896 19.2838 49.0962 19.2967 49.2641 19.3096C49.4319 19.3225 49.574 19.3225 49.6902 19.3225C49.7805 19.3225 49.8967 19.3225 50.0516 19.3096C50.2066 19.2967 50.4131 19.2967 50.6843 19.2709V19.6969C50.426 19.7227 50.2582 19.7614 50.155 19.826C50.0646 19.8906 49.9871 19.9939 49.9354 20.1617L48.2054 25.1194C48.1021 25.4164 47.9859 25.7263 47.8697 26.0361C47.7406 26.346 47.6244 26.6817 47.4824 27.0303L46.953 26.9657L44.4871 20.3941L44.4742 20.3554C44.3193 19.9293 44.0352 19.7098 43.635 19.7098L43.6221 19.2579Z",
    fill: "url(#paint297_radial_578_447510)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5852 24.9896L46.0101 20.5353C45.9714 20.4191 45.9456 20.3288 45.9197 20.2513C45.9068 20.1739 45.894 20.0964 45.894 20.0447C45.894 19.9673 45.9069 19.9027 45.9456 19.8511C45.8681 19.864 45.8165 19.8898 45.7649 19.9027C45.6745 19.9543 45.6357 20.0447 45.6357 20.1738C45.6357 20.2384 45.6486 20.303 45.6615 20.3804C45.6744 20.4579 45.7132 20.5482 45.7519 20.6644L47.4433 25.4286L47.5852 24.9896Z",
    fill: "url(#paint298_radial_578_447510)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2547 19.4252C44.5 19.4381 44.6937 19.438 44.8357 19.438C45.0164 19.438 45.365 19.4252 45.9072 19.3993C46.1138 19.3864 46.2558 19.3864 46.3591 19.3864V19.6963C46.4366 19.6834 46.527 19.6834 46.6173 19.6834V19.2573C46.5141 19.2573 46.3591 19.2702 46.1655 19.2702C45.6361 19.2961 45.2746 19.3089 45.0939 19.3089C44.9519 19.3089 44.7582 19.2961 44.5129 19.2961C44.2676 19.2832 43.9707 19.2702 43.6221 19.2444V19.3864C43.8674 19.4122 44.0739 19.4252 44.2547 19.4252Z",
    fill: "url(#paint299_radial_578_447510)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0385 19.2961C49.8836 19.309 49.7674 19.3089 49.677 19.3089C49.5608 19.3089 49.4189 19.309 49.251 19.2961C49.0832 19.2832 48.8637 19.2831 48.6055 19.2573V19.3993C48.7604 19.4123 48.8766 19.4123 48.9928 19.4123C49.1606 19.4252 49.3026 19.4252 49.4188 19.4252C49.5092 19.4252 49.6254 19.4252 49.7803 19.4123C49.9352 19.3994 50.1419 19.3993 50.413 19.3735V19.7092C50.4904 19.6963 50.5808 19.6834 50.6712 19.6705V19.2444C50.3872 19.2702 50.1805 19.2832 50.0385 19.2961Z",
    fill: "url(#paint300_radial_578_447510)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8832 19.9291C49.7928 19.9937 49.7153 20.097 49.6637 20.2648L47.9336 25.2226C47.8303 25.5195 47.7141 25.8294 47.5979 26.1393C47.4946 26.4104 47.3914 26.6944 47.2881 26.9785L47.4947 26.9913C47.6238 26.6427 47.7529 26.32 47.882 25.9972C48.0111 25.6874 48.1144 25.3775 48.2177 25.0806L49.9477 20.1228C49.9865 19.9937 50.0381 19.9033 50.1155 19.8387C49.9993 19.8775 49.9348 19.9033 49.8832 19.9291Z",
    fill: "url(#paint301_radial_578_447510)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.6136 10.8149) rotate(58.5735) scale(11.0418 11.0405)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000561768,
    stopColor: "#00D8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5338,
    stopColor: "#C5FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#00DDB3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.6854 13.6323) rotate(58.5736) scale(14.3939 14.3922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03896F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15CCAF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.306 7.30205) rotate(58.5736) scale(12.3467 12.3453)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37C49F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.7243 13.0678) rotate(59.9934) scale(0.218486 0.218487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.621 13.1746) rotate(59.9926) scale(0.00753128)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.3401 10.9448) rotate(59.9839) scale(5.81626 5.81564)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.7915 7.49453) rotate(59.984) scale(6.72422 6.72351)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.578 6.32319) rotate(59.9844) scale(2.07967 2.07946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4762 11.0976) rotate(59.9841) scale(9.60835 9.60734)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.7619 9.89648) rotate(59.9856) scale(2.63211 2.63188)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03896F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15CCAF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.0054 8.78239) rotate(58.5737) scale(5.10375 5.10314)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.3904 10.8258) rotate(116.073) scale(11.0418 11.0404)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000561768,
    stopColor: "#00D8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5338,
    stopColor: "#C5FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#00DDB3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.6035 14.1042) rotate(116.073) scale(14.3939 14.3922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03896F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15CCAF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.3895 7.76618) rotate(116.073) scale(12.3467 12.3453)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37C49F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.4032 13.1943) rotate(114.654) scale(0.218485 0.218487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.5131 13.2951) rotate(114.654) scale(0.00753128)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6016 11.3244) rotate(114.663) scale(5.81626 5.81564)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.8079 7.46475) rotate(114.663) scale(6.72422 6.72351)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.9508 7.11829) rotate(114.663) scale(2.07967 2.07946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.4847 11.5822) rotate(114.663) scale(9.60835 9.60734)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.0875 10.4131) rotate(114.661) scale(2.63211 2.63188)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03896F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15CCAF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.811 8.8388) rotate(116.073) scale(5.10375 5.10314)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.958 48.4305) scale(22.9408 22.9335)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000561768,
    stopColor: "#00D8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5338,
    stopColor: "#C5FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#00DDB3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.6033 49.2347) scale(10.4729 10.4696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8409 28.0571) scale(25.8693 25.8611)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37C49F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4184 38.4831) scale(12.5081 12.504)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03896F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15CCAF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5875 45.74) scale(21.633 21.6261)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.4892 38.0266) scale(9.87586 9.87271)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.9171 41.312) scale(11.8261 11.8223)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#2AD7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.4414 32.5153) scale(20.3383 20.3318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.2261 33.8155) scale(6.08905 6.08713)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.7742 35.5138) scale(6.84429 6.84197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.7381 29.9342) scale(19.9956 19.9892)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.5121 31.3286) scale(13.0919 13.0877)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.7304 30.7819) scale(24.5969 24.5892)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#2AD7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.5026 32.179) scale(21.7099 21.703)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.1799 33.6032) scale(7.44495 7.44247)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.4961 31.9787) scale(7.14119 7.13889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.3459 30.9192) scale(29.1545 29.1453)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.9544 30.0565) scale(11.7019 11.6982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.078 19.6915) scale(23.8645 23.857)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#2AD7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.2536 31.3044) scale(37.484 37.4723)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.4455 33.0219) scale(26.4989 26.4905)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.9219 29.1552) rotate(1.57188) scale(8.01513 8.01256)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.8551 22.3862) scale(9.99201 9.98885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.2338 28.4951) scale(27.0089 27.0003)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.8259 11.8091) scale(29.0185 29.0094)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#2AD7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.7376 33.871) scale(45.0295 45.0152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.0629 34.3058) scale(42.609 42.5955)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.0806 22.9564) scale(8.58054 8.57786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.8415 13.3465) scale(6.80768 6.80554)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.9119 15.4825) rotate(7.46731) scale(26.9605 26.9523)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#2AD7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.8911 22.0358) rotate(7.46739) scale(9.12847 9.12578)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.9976 15.2085) rotate(7.4675) scale(6.19995 6.19821)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.7535 24.4399) rotate(7.46728) scale(16.6954 16.6903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    stopColor: "#F265A0",
    stopOpacity: 0.6961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#E5B7D3",
    stopOpacity: 0.3575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8827,
    stopColor: "#DCEBF3",
    stopOpacity: 0.1172
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#D9FFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.9344 21.7901) rotate(13.6917) scale(8.9022 8.89969)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.4594 15.7013) rotate(13.6918) scale(25.0293 25.0222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#2AD7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.4424 32.0958) rotate(13.6917) scale(22.0267 22.0205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.1503 26.1661) rotate(13.6917) scale(23.601 23.5943)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    stopColor: "#F265A0",
    stopOpacity: 0.6961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#E5B7D3",
    stopOpacity: 0.3575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8827,
    stopColor: "#DCEBF3",
    stopOpacity: 0.1172
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#D9FFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.9589 27.3051) rotate(13.6917) scale(9.79677 9.79399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.3124 21.7729) rotate(13.6917) scale(17.5454 17.5404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.844 15.9015) rotate(13.6917) scale(9.20472 9.20208)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.0283 24.28) rotate(13.6918) scale(20.3495 20.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#2AD7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.2103 37.6751) rotate(13.6918) scale(21.3246 21.3186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.0783 27.7393) rotate(13.6916) scale(14.2083 14.2042)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.4764 29.2161) rotate(13.6918) scale(18.399 18.3938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.3955 23.1401) rotate(13.6919) scale(9.87323 9.87052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.5219 15.6434) rotate(-26.0517) scale(12.7875 12.785)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000561768,
    stopColor: "#00D8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5338,
    stopColor: "#C5FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#00DDB3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.2998 5.85798) rotate(-26.0517) scale(31.8582 31.852)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.4059 7.4922) rotate(-26.0517) scale(21.2554 21.2512)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37C49F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.0067 4.83624) rotate(-26.0518) scale(21.6813 21.6771)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2321 18.2969) rotate(-26.0517) scale(8.08094 8.07936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.5582 13.7155) rotate(-26.0516) scale(4.88156 4.88059)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.9677 12.6182) rotate(-26.0518) scale(10.61 10.6079)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.5297 14.0912) rotate(-26.0517) scale(11.6642 11.6619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.7 19.1171) rotate(-26.0518) scale(15.54 15.537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.7017 10.6084) rotate(-26.0517) scale(18.2399 18.2364)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.3571 6.75967) rotate(-26.0517) scale(12.1047 12.1023)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.6318 5.9492) rotate(-26.0518) scale(7.02775 7.0264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03896F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15CCAF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.8604 19.4353) rotate(-12.118) scale(11.0019 10.9986)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000561768,
    stopColor: "#00D8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5338,
    stopColor: "#C5FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#00DDB3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.0434 12.0468) rotate(-12.1181) scale(27.4097 27.4017)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.4633 13.8476) rotate(-12.1181) scale(18.2874 18.282)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37C49F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.1851 12.1687) rotate(-12.118) scale(18.6538 18.6483)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.7276 20.7623) rotate(-12.118) scale(6.95254 6.95049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.6298 18.6613) rotate(-12.118) scale(4.19994 4.19868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.5197 16.1723) rotate(-12.118) scale(9.12844 9.12574)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.5189 17.7267) rotate(-12.1181) scale(10.0355 10.0326)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4342 19.6801) rotate(-12.1181) scale(13.3701 13.3662)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2093 13.8184) rotate(-12.1181) scale(15.693 15.6884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.2338 12.3979) rotate(-12.1182) scale(10.4145 10.4115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.9714 12.6061) rotate(-12.118) scale(6.04634 6.04455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03896F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15CCAF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.2089 24.1468) rotate(-0.516893) scale(11.0028 10.9993)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000561768,
    stopColor: "#00D8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5338,
    stopColor: "#C5FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#00DDB3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.7731 17.95) rotate(-0.516895) scale(27.412 27.4035)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.8016 19.9998) rotate(-0.516895) scale(18.2889 18.2832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37C49F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.8058 18.9025) rotate(-0.516896) scale(18.6554 18.6496)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.8939 24.615) rotate(-0.517089) scale(6.95309 6.95354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.0575 24.1464) rotate(-0.516896) scale(4.20028 4.19899)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.5722 20.4792) rotate(-0.516895) scale(9.12916 9.12632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.2389 22.2026) rotate(-0.51689) scale(10.0363 10.0331)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9668 22.0872) rotate(-0.516889) scale(13.3712 13.3669)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.7836 17.7084) rotate(-0.51689) scale(15.6942 15.6892)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.9296 17.9306) rotate(-0.516899) scale(10.4153 10.4122)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.5488 18.8863) rotate(-0.516879) scale(6.0469 6.04483)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03896F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15CCAF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.1826 41.3118) rotate(180) scale(11.8261 11.8223)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#2AD7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.6588 32.5151) rotate(180) scale(20.3383 20.3318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8733 33.8154) rotate(180) scale(6.089 6.08713)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.3256 35.5137) rotate(180) scale(6.84426 6.84197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3621 29.9337) rotate(180) scale(19.9956 19.9892)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.5882 31.3284) rotate(180) scale(13.0919 13.0877)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.36906 30.7818) rotate(180) scale(24.5969 24.5892)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#2AD7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.5978 32.1787) rotate(180) scale(21.7099 21.703)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9184 33.603) rotate(180) scale(7.44495 7.44247)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.6034 31.9786) rotate(180) scale(7.14119 7.13889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.7536 30.9191) rotate(180) scale(29.1545 29.1453)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1457 30.0562) rotate(180) scale(11.7019 11.6982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.02003 19.6914) rotate(180) scale(23.8646 23.857)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#2AD7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.8452 31.3042) rotate(180) scale(37.484 37.4723)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6529 33.0218) rotate(180) scale(26.4989 26.4905)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.1911 29.1543) rotate(178.428) scale(8.01517 8.01256)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.24324 22.3861) rotate(180) scale(9.99199 9.98885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.8646 28.495) rotate(180) scale(27.0089 27.0003)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2732 11.8089) rotate(180) scale(29.0185 29.0094)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#2AD7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.3621 33.8707) rotate(180) scale(45.0296 45.0152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.0371 34.3057) rotate(180) scale(42.609 42.5955)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0189 22.9562) rotate(180) scale(8.58059 8.57786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.25688 13.3465) rotate(180) scale(6.80768 6.80554)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2202 15.4914) rotate(172.533) scale(26.9605 26.9523)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#2AD7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.2429 22.045) rotate(172.533) scale(9.12869 9.12578)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.1355 15.2177) rotate(172.533) scale(6.20019 6.19822)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3786 24.449) rotate(172.533) scale(16.6955 16.6903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    stopColor: "#F265A0",
    stopOpacity: 0.6961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#E5B7D3",
    stopOpacity: 0.3575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8827,
    stopColor: "#DCEBF3",
    stopOpacity: 0.1172
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#D9FFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.1761 21.7556) rotate(166.308) scale(8.90218 8.89969)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.6514 15.6662) rotate(166.308) scale(25.0293 25.0222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#2AD7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6675 32.0612) rotate(166.308) scale(22.0267 22.0205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.9599 26.1316) rotate(166.308) scale(23.601 23.5943)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    stopColor: "#F265A0",
    stopOpacity: 0.6961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#E5B7D3",
    stopOpacity: 0.3575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8827,
    stopColor: "#DCEBF3",
    stopOpacity: 0.1172
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#D9FFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.152 27.2705) rotate(166.308) scale(9.79677 9.79399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7987 21.7381) rotate(166.308) scale(17.5454 17.5404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2657 15.866) rotate(166.308) scale(9.20472 9.20208)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.0824 24.2452) rotate(166.308) scale(20.3495 20.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#2AD7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9006 37.6405) rotate(166.308) scale(21.3246 21.3186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.0325 27.7046) rotate(166.308) scale(14.2083 14.2042)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6343 29.1813) rotate(166.308) scale(18.399 18.3938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.7152 23.1054) rotate(166.308) scale(9.87323 9.87052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AD7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.562 15.6144) rotate(-153.948) scale(12.7875 12.785)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000561768,
    stopColor: "#00D8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5338,
    stopColor: "#C5FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#00DDB3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.7848 5.82863) rotate(-153.948) scale(31.8583 31.8521)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.6786 7.46285) rotate(-153.948) scale(21.2554 21.2512)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37C49F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0779 4.80724) rotate(-153.948) scale(21.6813 21.6771)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.853 18.268) rotate(-153.948) scale(8.08094 8.07936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.527 13.6863) rotate(-153.949) scale(4.88161 4.8806)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.1175 12.5892) rotate(-153.948) scale(10.61 10.6079)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.554 14.0621) rotate(-153.948) scale(11.6642 11.6619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.3846 19.088) rotate(-153.948) scale(15.5401 15.537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.382 10.5793) rotate(-153.948) scale(18.2399 18.2364)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.7283 6.73055) rotate(-153.948) scale(12.1047 12.1023)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.4523 5.9201) rotate(-153.948) scale(7.02768 7.02638)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03896F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15CCAF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2733 19.4578) rotate(-167.882) scale(11.0019 10.9986)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000561768,
    stopColor: "#00D8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5338,
    stopColor: "#C5FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#00DDB3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.09 12.0696) rotate(-167.882) scale(27.4097 27.4017)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.6701 13.8704) rotate(-167.882) scale(18.2874 18.282)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37C49F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9491 12.1912) rotate(-167.882) scale(18.6538 18.6483)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.4058 20.7849) rotate(-167.882) scale(6.95249 6.95048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5046 18.6838) rotate(-167.882) scale(4.19994 4.19868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6147 16.1948) rotate(-167.882) scale(9.12844 9.12574)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6154 17.7492) rotate(-167.882) scale(10.0355 10.0326)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.7007 19.7026) rotate(-167.882) scale(13.37 13.3662)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.9257 13.8409) rotate(-167.882) scale(15.693 15.6884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.9004 12.4204) rotate(-167.882) scale(10.4145 10.4115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.1623 12.6287) rotate(-167.882) scale(6.04634 6.04455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03896F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15CCAF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.878 24.1471) rotate(-179.483) scale(11.0028 10.9993)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000561768,
    stopColor: "#00D8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5338,
    stopColor: "#C5FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#00DDB3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.3139 17.9509) rotate(-179.483) scale(27.412 27.4035)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.2855 20.0006) rotate(-179.483) scale(18.2889 18.2832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37C49F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2817 18.9033) rotate(-179.483) scale(18.6554 18.6496)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.194 24.6152) rotate(-179.483) scale(6.95313 6.95354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0297 24.1467) rotate(-179.483) scale(4.20028 4.19899)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5157 20.4796) rotate(-179.483) scale(9.12916 9.12632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.8478 22.2029) rotate(-179.483) scale(10.0363 10.0331)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.1206 22.0876) rotate(-179.483) scale(13.3712 13.3669)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3038 17.7087) rotate(-179.483) scale(15.6942 15.6892)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00845E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1566 17.931) rotate(-179.483) scale(10.4153 10.4122)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5378 18.8865) rotate(-179.483) scale(6.0469 6.04483)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03896F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15CCAF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3181 30.1686) scale(16.1351 16.9149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#19A080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15CCAF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0718 36.8539) scale(16.5211 16.5158)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000561768,
    stopColor: "#00D8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5338,
    stopColor: "#C5FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#00DDB3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0346 8.31847) scale(38.428 38.4158)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37C49F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3144 5.70412) scale(14.1164 14.1119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#B6FFF4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.7819 30.5365) scale(14.5948 14.5901)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#67E4D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4755 23.6983) scale(26.52 6.76511)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#A2FBF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.4813 20.7983) rotate(-0.328289) scale(31.7217 6.86492)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03896F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15CCAF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.5808 9.94494) scale(24.8286 24.8208)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#B6FFF4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint186_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.2954 26.9587) scale(22.8366 22.8294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#67E4D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_578_447510",
    x1: 47.0771,
    y1: 37.6591,
    x2: 47.0771,
    y2: 4.47762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00129337,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4195,
    stopColor: "#31FFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#146652"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.9726 18.6933) scale(22.2815 22.2744)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4015 16.0724) scale(24.1559 24.1482)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00147628,
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#81F7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#1BAF88"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint190_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.5766 12.9715) scale(9.41393 9.41093)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#67E4D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0765 33.2251) scale(17.7345 17.7288)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#67E4D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_578_447510",
    x1: 47.0864,
    y1: 10.5142,
    x2: 47.0864,
    y2: 37.7913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    stopColor: "#2BCC8A",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007769",
    stopOpacity: 0.9811
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.41 24.2475) scale(17.2556 17.2501)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#67E4D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint194_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.6892 28.063) scale(26.6719 26.6634)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#67E4D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint195_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.2436 15.8391) scale(12.4996 12.4957)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03896F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15CCAF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_578_447510",
    x1: 47.0724,
    y1: 34.6249,
    x2: 47.0724,
    y2: 8.22949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4252,
    stopColor: "#007F5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#146652"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.6966 4.20363) scale(48.4811 48.4657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#67E4D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.4552 27.6216) scale(12.6135 12.6095)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03896F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15CCAF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.534 15.3805) scale(5.04569 5.04406)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03896F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15CCAF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.1954 28.0015) scale(3.40066 3.39956)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#67E4D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0679 11.4986) scale(42.7396 42.726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00147628,
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#81F7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#1BAF88"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.1128 27.0439) scale(14.3515 14.3469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#67E4D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint203_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.6365 18.1962) scale(12.9453 12.9411)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#67E4D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.8941 24.049) scale(9.64599 9.64286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#67E4D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.375 34.8896) rotate(180) scale(5.10753 5.09935)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#D64765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint206_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.4345 37.7484) rotate(180) scale(2.61767 2.61348)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.2176 35.0633) rotate(180) scale(2.55377 2.54968)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint208_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.0032 36.2159) rotate(180) scale(3.44393 3.43841)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint209_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.8615 38.2662) rotate(180) scale(2.07473 2.07141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint210_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.9643 36.0028) rotate(180) scale(2.38034 2.37653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint211_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.2539 36.1317) rotate(180) scale(3.55928 3.55358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint212_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.935 39.639) rotate(180) scale(3.64304 3.6372)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint213_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.6986 35.0389) rotate(180) scale(2.19109 2.18758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint214_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.3421 36.2982) rotate(180) scale(4.95084 4.94292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FDD1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint215_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.3506 35.0601) rotate(180) scale(3.22033 3.21517)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FDD1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint216_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.3504 38.6736) rotate(180) scale(2.85423 2.84966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint217_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.3504 38.6737) rotate(180) scale(2.85423 2.84966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint218_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.555 36.1829) rotate(180) scale(2.2666 2.26297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint219_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.4109 37.8451) rotate(180) scale(1.97135 1.96819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint220_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.4428 36.9673) rotate(-90) scale(1.96819 1.97135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint221_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.3092 36.8781) rotate(90) scale(1.96819 1.97135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint222_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.3216 35.9997) scale(1.97135 1.96819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint223_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.7148 38.3166) rotate(180) scale(5.10753 5.09935)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#D64765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint224_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.7744 41.1754) rotate(180) scale(2.61767 2.61348)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint225_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.5575 38.4903) rotate(180) scale(2.55377 2.54968)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint226_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.343 39.6429) rotate(180) scale(3.44393 3.43841)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint227_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.2013 41.6932) rotate(180) scale(2.07473 2.07141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint228_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.3042 39.4298) rotate(180) scale(2.38034 2.37653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint229_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.5937 39.5587) rotate(180) scale(3.55928 3.55358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint230_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.2748 43.066) rotate(180) scale(3.64304 3.6372)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint231_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.0384 38.4659) rotate(180) scale(2.19109 2.18758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint232_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.682 39.7252) rotate(180) scale(4.95084 4.94292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FDD1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint233_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.6904 38.4871) rotate(180) scale(3.22033 3.21517)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FDD1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint234_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.6902 42.1006) rotate(180) scale(2.85423 2.84966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint235_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.6902 42.1007) rotate(180) scale(2.85423 2.84966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint236_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.8949 39.6099) rotate(180) scale(2.2666 2.26297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint237_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.7508 41.2721) rotate(180) scale(1.97135 1.96819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint238_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.7826 40.3943) rotate(-90) scale(1.96819 1.97135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint239_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6491 40.3051) rotate(90) scale(1.96819 1.97135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint240_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.6614 39.4267) scale(1.97135 1.96819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint241_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0556 41.4749) rotate(180) scale(5.10753 5.09935)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#D64765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint242_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.1152 44.3337) rotate(180) scale(2.61767 2.61348)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint243_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.8983 41.6487) rotate(180) scale(2.55377 2.54968)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint244_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6838 42.8012) rotate(180) scale(3.44393 3.43841)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint245_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5422 44.8515) rotate(180) scale(2.07473 2.07141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint246_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.645 42.5882) rotate(180) scale(2.38034 2.37653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint247_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.9345 42.717) rotate(180) scale(3.55928 3.55358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint248_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.6156 46.2243) rotate(180) scale(3.64304 3.6372)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint249_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3792 41.6242) rotate(180) scale(2.19109 2.18758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint250_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0228 42.8835) rotate(180) scale(4.95084 4.94292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FDD1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint251_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0312 41.6455) rotate(180) scale(3.22033 3.21517)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FDD1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint252_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.031 45.259) rotate(180) scale(2.85423 2.84966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint253_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.031 45.259) rotate(180) scale(2.85423 2.84966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint254_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.2357 42.7682) rotate(180) scale(2.2666 2.26297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint255_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0916 44.4304) rotate(180) scale(1.97135 1.96819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint256_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.1234 43.5526) rotate(-90) scale(1.96819 1.97135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint257_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9899 43.4634) rotate(90) scale(1.96819 1.97135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint258_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0023 42.585) scale(1.97135 1.96819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint259_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.3955 38.3166) rotate(180) scale(5.10753 5.09935)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#D64765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint260_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4551 41.1754) rotate(180) scale(2.61767 2.61348)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint261_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.2381 38.4903) rotate(180) scale(2.55377 2.54968)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint262_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.0237 39.6429) rotate(180) scale(3.44393 3.43841)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint263_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.882 41.6932) rotate(180) scale(2.07473 2.07141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint264_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.9848 39.4298) rotate(180) scale(2.38034 2.37653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint265_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.2744 39.5587) rotate(180) scale(3.55928 3.55358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint266_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.9555 43.066) rotate(180) scale(3.64304 3.6372)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint267_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.7191 38.4659) rotate(180) scale(2.19109 2.18758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint268_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.3626 39.7252) rotate(180) scale(4.95084 4.94292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FDD1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint269_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.3711 38.4871) rotate(180) scale(3.22033 3.21517)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FDD1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint270_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.3709 42.1006) rotate(180) scale(2.85423 2.84966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint271_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.3709 42.1007) rotate(180) scale(2.85423 2.84966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint272_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.5756 39.6099) rotate(180) scale(2.2666 2.26297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint273_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.4315 41.2721) rotate(180) scale(1.97135 1.96819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint274_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.4633 40.3943) rotate(-90) scale(1.96819 1.97135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint275_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.3297 40.3051) rotate(90) scale(1.96819 1.97135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint276_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.3421 39.4267) scale(1.97135 1.96819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint277_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7001 34.8896) rotate(180) scale(5.10753 5.09935)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#D64765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint278_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.7597 37.7484) rotate(180) scale(2.61767 2.61348)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint279_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5428 35.0633) rotate(180) scale(2.55377 2.54968)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint280_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.3284 36.2159) rotate(180) scale(3.44393 3.43841)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint281_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.1867 38.2662) rotate(180) scale(2.07473 2.07141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint282_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2895 36.0028) rotate(180) scale(2.38034 2.37653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint283_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5791 36.1317) rotate(180) scale(3.55928 3.55358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint284_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2602 39.639) rotate(180) scale(3.64304 3.6372)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint285_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.0238 35.0389) rotate(180) scale(2.19109 2.18758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint286_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6673 36.2982) rotate(180) scale(4.95084 4.94292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FDD1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint287_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6758 35.0601) rotate(180) scale(3.22033 3.21517)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FDD1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint288_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6756 38.6736) rotate(180) scale(2.85423 2.84966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint289_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6756 38.6737) rotate(180) scale(2.85423 2.84966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint290_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.8802 36.1829) rotate(180) scale(2.2666 2.26297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint291_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7361 37.8451) rotate(180) scale(1.97135 1.96819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint292_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.768 36.9673) rotate(-90) scale(1.96819 1.97135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint293_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6344 36.8781) rotate(90) scale(1.96819 1.97135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint294_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6468 35.9997) scale(1.97135 1.96819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_578_447510",
    x1: 43.7429,
    y1: 23.0575,
    x2: 50.8037,
    y2: 23.0575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DCC8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5371,
    stopColor: "#055B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13A376",
    stopOpacity: 0.9811
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint296_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1593 21.4883) scale(10.833 10.833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#6DE5D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint297_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5759 21.5422) scale(4.90147 4.90151)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A9B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5209,
    stopColor: "#408269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C8C63"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint298_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1705 21.8646) scale(14.7461 14.7465)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000365803,
    stopColor: "#00351D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397C5C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint299_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.6203 18.484) scale(8.44886 8.44897)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000365803,
    stopColor: "#00351D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397C5C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint300_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.1263 18.6739) scale(6.48801 6.48819)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000365803,
    stopColor: "#00351D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397C5C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint301_radial_578_447510",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7903 22.1183) scale(15.0854 15.0855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000365803,
    stopColor: "#00351D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397C5C",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmerald);
export default __webpack_public_path__ + "static/media/emerald.0ed17a32db25178de5bd3bd83527f428.svg";
export { ForwardRef as ReactComponent };